

import { ISimpleTable } from './types';

export type ITableJpPlusKeys = "會" | "会" | "㑹" | "䇳" | "笺" | "箋" | "牋" | "網" | "䋄" | "䋞" | "网" | "處" | "处" | "䖏" | "処" | "話" | "话" | "䛡" | "駄" | "䭾" | "馱" | "驮" | "専" | "專" | "专" | "糸" | "絲" | "丝" | "両" | "两" | "兩" | "並" | "并" | "併" | "為" | "为" | "爲" | "麼" | "麽" | "樂" | "乐" | "楽" | "乡" | "郷" | "鄕" | "鄉" | "鄊" | "亀" | "龜" | "龟" | "𪚧" | "𪚿" | "𠃾" | "貳" | "贰" | "弐" | "貮" | "𢎐" | "二" | "於" | "亘" | "亙" | "亜" | "亞" | "亚" | "産" | "產" | "产" | "她" | "他" | "伙" | "夥" | "偽" | "僞" | "布" | "佈" | "祐" | "佑" | "餘" | "馀" | "余" | "妳" | "你" | "儘" | "侮" | "侮" | "俱" | "倶" | "藉" | "傑" | "杰" | "家" | "傢" | "像" | "象" | "雇" | "僱" | "盡" | "尽" | "凶" | "兇" | "勉" | "勉" | "兎" | "兔" | "內" | "内" | "関" | "關" | "关" | "茲" | "兹" | "玆" | "氷" | "冰" | "衝" | "沖" | "冲" | "淨" | "凈" | "净" | "塗" | "凃" | "涂" | "悽" | "淒" | "凄" | "準" | "淩" | "凌" | "凖" | "擊" | "撃" | "击" | "凼" | "氹" | "刃" | "刄" | "劫" | "刦" | "刧" | "刼" | "剷" | "鏟" | "铲" | "刬" | "剗" | "剁" | "刴" | "劵" | "券" | "卷" | "劍" | "剑" | "剣" | "劎" | "劒" | "剱" | "劔" | "箚" | "剳" | "剿" | "勦" | "𠞰" | "擗" | "劈" | "労" | "勞" | "劳" | "效" | "効" | "勛" | "勳" | "勋" | "勲" | "猛" | "勐" | "升" | "昇" | "単" | "單" | "单" | "滷" | "鹵" | "卤" | "衛" | "衞" | "卫" | "歴" | "暦" | "歷" | "曆" | "壓" | "压" | "圧" | "崖" | "崕" | "厓" | "廄" | "厩" | "廐" | "廏" | "县" | "県" | "縣" | "蔘" | "參" | "参" | "收" | "収" | "髮" | "敘" | "叙" | "敍" | "閤" | "阁" | "向" | "曏" | "嚮" | "吒" | "咤" | "噸" | "吨" | "聴" | "聽" | "听" | "启" | "啓" | "啟" | "啔" | "吿" | "告" | "獃" | "呆" | "周" | "週" | "呪" | "咒" | "詋" | "諮" | "谘" | "咨" | "咸" | "鹹" | "唖" | "啞" | "哑" | "哗" | "嘩" | "譁" | "脣" | "唇" | "齧" | "啮" | "𪘂" | "囓" | "噛" | "嚙" | "喂" | "餵" | "餧" | "𫗭" | "喻" | "喩" | "営" | "營" | "营" | "嚐" | "嘗" | "尝" | "嬉" | "嘻" | "恶" | "蘇" | "苏" | "囌" | "廻" | "迴" | "団" | "团" | "團" | "国" | "囯" | "國" | "圈" | "圏" | "坏" | "坯" | "壊" | "壞" | "牆" | "墙" | "墻" | "殻" | "殼" | "壳" | "壶" | "壺" | "壷" | "复" | "復" | "複" | "犇" | "奔" | "姉" | "姐" | "姊" | "薑" | "姜" | "葁" | "姫" | "姬" | "孃" | "嬢" | "娯" | "娛" | "娱" | "娴" | "嫺" | "嫻" | "肉" | "宍" | "𠕎" | "實" | "実" | "实" | "寔" | "祕" | "秘" | "対" | "對" | "对" | "尋" | "寻" | "𡬶" | "爾" | "尔" | "尓" | "尨" | "狵" | "歲" | "歳" | "岁" | "岩" | "巖" | "巗" | "巌" | "険" | "險" | "险" | "嶮" | "崄" | "谿" | "嵠" | "帯" | "帶" | "带" | "庅" | "廢" | "廃" | "废" | "廸" | "迪" | "録" | "錄" | "录" | "彷" | "徬" | "徵" | "徴" | "御" | "禦" | "憂" | "懐" | "懷" | "怀" | "恆" | "恒" | "悪" | "惡" | "悠" | "滺" | "癒" | "瘉" | "栗" | "慄" | "欲" | "慾" | "𢝊" | "𢚧" | "𢟜" | "懮" | "𨗫" | "戰" | "戦" | "战" | "紮" | "扎" | "託" | "讬" | "托" | "拡" | "擴" | "扩" | "扵" | "折" | "摺" | "拔" | "抜" | "據" | "据" | "拠" | "挽" | "輓" | "插" | "挿" | "揷" | "捶" | "撚" | "捻" | "搥" | "搾" | "榨" | "教" | "敎" | "鬥" | "鬭" | "闘" | "鬪" | "昵" | "暱" | "曉" | "晓" | "暁" | "晚" | "晩" | "暗" | "闇" | "樸" | "朴" | "雑" | "雜" | "杂" | "權" | "権" | "权" | "杯" | "盃" | "鎗" | "槍" | "枪" | "査" | "查" | "栖" | "棲" | "様" | "樣" | "样" | "核" | "覈" | "櫻" | "桜" | "樱" | "樑" | "梁" | "檢" | "検" | "检" | "楕" | "椭" | "橢" | "簷" | "檐" | "歓" | "歡" | "欢" | "步" | "歩" | "毎" | "每" | "氣" | "気" | "气" | "污" | "汙" | "汚" | "沉" | "沈" | "砂" | "沙" | "泄" | "洩" | "泪" | "涙" | "淚" | "済" | "濟" | "济" | "浜" | "濱" | "滨" | "涌" | "湧" | "溪" | "渓" | "遊" | "游" | "湿" | "溼" | "濕" | "灕" | "漓" | "霊" | "靈" | "灵" | "灶" | "竈" | "炭" | "碳" | "砲" | "炮" | "鍊" | "錬" | "𫔀" | "炼" | "煉" | "煙" | "烟" | "菸" | "焼" | "燒" | "烧" | "焰" | "焔" | "鍛" | "锻" | "煅" | "薫" | "熏" | "薰" | "牺" | "犠" | "犧" | "获" | "獲" | "穫" | "瓮" | "罋" | "甕" | "痲" | "痳" | "痴" | "癡" | "痺" | "痹" | "蓋" | "盖" | "葢" | "磐" | "盤" | "盘" | "盪" | "蕩" | "荡" | "視" | "視" | "视" | "眎" | "瞪" | "瞠" | "眙" | "鹼" | "碱" | "硷" | "禍" | "禍" | "祸" | "稻" | "稲" | "糓" | "穀" | "穗" | "穂" | "竝" | "𠀤" | "篦" | "箆" | "範" | "范" | "藤" | "籐" | "籘" | "籲" | "龥" | "粘" | "黏" | "肅" | "粛" | "肃" | "粽" | "糉" | "糭" | "繫" | "繋" | "経" | "經" | "经" | "絶" | "絕" | "绝" | "絵" | "繪" | "绘" | "継" | "繼" | "继" | "綠" | "緑" | "绿" | "線" | "缐" | "綫" | "线" | "綳" | "繃" | "绷" | "纖" | "纤" | "縴" | "繊" | "繮" | "缰" | "韁" | "罵" | "骂" | "駡" | "耤" | "肢" | "胑" | "舖" | "铺" | "鋪" | "舗" | "館" | "館" | "舘" | "馆" | "艸" | "草" | "薬" | "藥" | "药" | "葯" | "𣛙" | "薩" | "萨" | "蕯" | "蔵" | "藏" | "蛎" | "蜊" | "蠣" | "裡" | "裏" | "里" | "裸" | "躶" | "霸" | "覇" | "観" | "觀" | "观" | "覌" | "覧" | "覽" | "览" | "證" | "証" | "证" | "諸" | "諸" | "诸" | "讚" | "讃" | "賎" | "賤" | "贱" | "贊" | "赞" | "賛" | "贋" | "贗" | "赝" | "贑" | "𫎬" | "蹠" | "跖" | "蹟" | "跡" | "迹" | "蹤" | "踪" | "踨" | "辺" | "邊" | "边" | "邉" | "鬱" | "郁" | "釈" | "釋" | "释" | "鉄" | "鐵" | "铁" | "鐡" | "鑑" | "鉴" | "鑒" | "銭" | "錢" | "钱" | "銳" | "鋭" | "锐" | "鏽" | "銹" | "锈" | "鎚" | "錘" | "锤" | "鐘" | "鍾" | "钟" | "锺" | "閒" | "𫔮" | "閑" | "闲" | "閲" | "阅" | "隷" | "隸" | "隶" | "鶏" | "鷄" | "雞" | "鸡" | "黴" | "霉" | "麵" | "麪" | "颜" | "顏" | "顔" | "驗" | "验" | "騐" | "験" | "騨" | "驒" | "驔" | "髪" | "鱷" | "鰐" | "鳄" | "鳥" | "鸟" | "𫠓" | "鶇" | "鶫" | "鸫" | "麺" | "黒" | "黑" | "默" | "黙"

/**
 * 此表內符合以下任意值時會觸發
 */
export const table_plus: Record<ITableJpPlusKeys, string[]> = {
	"劍": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"砲": [
		"砲",
		"炮"
	],
	"偽": [
		"偽",
		"僞"
	],
	"內": [
		"內",
		"内"
	],
	"鬥": [
		"鬭",
		"鬥",
		"闘",
		"鬪"
	],
	"鶏": [
		"鶏",
		"鷄",
		"雞",
		"鸡"
	],
	"兎": [
		"兎",
		"兔"
	],
	"坏": [
		"坯",
		"坏",
		"壊",
		"壞"
	],
	"殻": [
		"殻",
		"殼",
		"壳"
	],
	"像": [
		"像",
		"象"
	],
	"蘇": [
		"苏",
		"蘇",
		"囌"
	],
	"館": [
		"館",
		"館",
		"舘",
		"馆"
	],
	"鳥": [
		"鳥",
		"鸟",
		"𫠓"
	],
	"視": [
		"視",
		"視",
		"视",
		"眎"
	],
	"険": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"絶": [
		"絶",
		"絕",
		"绝"
	],
	"鉄": [
		"鉄",
		"鐵",
		"铁",
		"鐡"
	],
	"諸": [
		"諸",
		"諸",
		"诸"
	],
	"尋": [
		"尋",
		"寻",
		"𡬶"
	],
	"裡": [
		"裡",
		"裏",
		"里"
	],
	"鑑": [
		"鑑",
		"鉴",
		"鑒"
	],
	"麵": [
		"麵",
		"麪",
		"麺"
	],
	"歲": [
		"歲",
		"歳",
		"岁"
	],
	"鐘": [
		"鐘",
		"鍾",
		"钟",
		"锺"
	],
	"會": [
		"會",
		"会",
		"㑹"
	],
	"塗": [
		"塗",
		"凃",
		"涂"
	],
	"髮": [
		"髮",
		"髪"
	],
	"話": [
		"話",
		"话",
		"䛡"
	],
	"閤": [
		"閤",
		"阁"
	],
	"蔘": [
		"蔘",
		"參",
		"参"
	],
	"労": [
		"労",
		"勞",
		"劳"
	],
	"国": [
		"国",
		"囯",
		"國"
	],
	"罵": [
		"罵",
		"骂",
		"駡"
	],
	"対": [
		"対",
		"對",
		"对"
	],
	"鏽": [
		"鏽",
		"銹",
		"锈"
	],
	"駄": [
		"駄",
		"䭾",
		"馱",
		"驮"
	],
	"薩": [
		"薩",
		"萨",
		"蕯"
	],
	"単": [
		"単",
		"單",
		"单"
	],
	"継": [
		"継",
		"繼",
		"继"
	],
	"驗": [
		"驗",
		"验",
		"騐",
		"験"
	],
	"歴": [
		"歴",
		"歷"
	],
	"暦": [
		"暦",
		"曆"
	],
	"団": [
		"团",
		"団",
		"團"
	],
	"麼": [
		"麼",
		"麽",
		"庅"
	],
	"戰": [
		"戦",
		"戰",
		"战"
	],
	"乡": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"勉": [
		"勉",
		"勉"
	],
	"餘": [
		"餘",
		"馀",
		"余"
	],
	"網": [
		"網",
		"䋄",
		"䋞",
		"网"
	],
	"託": [
		"託",
		"讬",
		"托"
	],
	"纖": [
		"纖",
		"纤",
		"縴",
		"繊"
	],
	"鍊": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"擊": [
		"撃",
		"擊",
		"击"
	],
	"實": [
		"實",
		"実",
		"实",
		"寔"
	],
	"於": [
		"於",
		"扵"
	],
	"證": [
		"證",
		"証",
		"证"
	],
	"據": [
		"據",
		"据",
		"拠"
	],
	"處": [
		"處",
		"处",
		"䖏",
		"処"
	],
	"瞪": [
		"瞪",
		"瞠",
		"眙"
	],
	"肢": [
		"肢",
		"胑"
	],
	"肉": [
		"肉",
		"宍",
		"𠕎"
	],
	"憂": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"繫": [
		"繫",
		"繋"
	],
	"廻": [
		"廻",
		"迴"
	],
	"録": [
		"録",
		"錄",
		"录"
	],
	"鎗": [
		"鎗",
		"槍",
		"枪"
	],
	"悠": [
		"悠",
		"滺"
	],
	"壶": [
		"壶",
		"壺",
		"壷"
	],
	"茲": [
		"茲",
		"兹",
		"玆"
	],
	"蓋": [
		"蓋",
		"盖",
		"葢"
	],
	"蹟": [
		"蹟",
		"跡",
		"迹"
	],
	"癒": [
		"癒",
		"瘉"
	],
	"辺": [
		"辺",
		"邊",
		"边",
		"邉"
	],
	"準": [
		"準",
		"凖"
	],
	"衛": [
		"衛",
		"衞",
		"卫"
	],
	"晚": [
		"晚",
		"晩"
	],
	"裸": [
		"裸",
		"躶"
	],
	"亀": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"凼": [
		"凼",
		"氹"
	],
	"艸": [
		"艸",
		"草"
	],
	"箚": [
		"箚",
		"剳"
	],
	"复": [
		"复",
		"復",
		"複"
	],
	"污": [
		"污",
		"汙",
		"汚"
	],
	"伙": [
		"伙",
		"夥"
	],
	"御": [
		"御",
		"禦"
	],
	"鬱": [
		"鬱",
		"郁"
	],
	"淩": [
		"淩",
		"凌"
	],
	"紮": [
		"紮",
		"扎"
	],
	"痴": [
		"痴",
		"癡"
	],
	"栖": [
		"栖",
		"棲"
	],
	"犇": [
		"犇",
		"奔"
	],
	"範": [
		"範",
		"范"
	],
	"薑": [
		"薑",
		"姜",
		"葁"
	],
	"樸": [
		"樸",
		"朴"
	],
	"諮": [
		"諮",
		"谘",
		"咨"
	],
	"撚": [
		"撚",
		"捻"
	],
	"喂": [
		"喂",
		"餵",
		"餧",
		"𫗭"
	],
	"淨": [
		"淨",
		"凈",
		"净"
	],
	"栗": [
		"栗",
		"慄"
	],
	"挽": [
		"挽",
		"輓"
	],
	"灶": [
		"灶",
		"竈"
	],
	"線": [
		"線",
		"缐",
		"綫",
		"线"
	],
	"盡": [
		"盡",
		"尽",
		"儘"
	],
	"黴": [
		"黴",
		"霉"
	],
	"周": [
		"周",
		"週"
	],
	"並": [
		"並",
		"并",
		"併"
	],
	"讚": [
		"讚",
		"讃"
	],
	"観": [
		"観",
		"觀",
		"观",
		"覌"
	],
	"遊": [
		"遊",
		"游"
	],
	"启": [
		"启",
		"啓",
		"啟",
		"啔"
	],
	"廄": [
		"廄",
		"厩",
		"廐",
		"廏"
	],
	"氣": [
		"気",
		"氣",
		"气"
	],
	"欲": [
		"慾",
		"欲"
	],
	"傑": [
		"傑",
		"杰"
	],
	"鍛": [
		"鍛",
		"锻",
		"煅"
	],
	"徵": [
		"徵",
		"徴"
	],
	"閒": [
		"閒",
		"𫔮",
		"閑",
		"闲"
	],
	"贊": [
		"贊",
		"赞",
		"賛"
	],
	"櫻": [
		"櫻",
		"桜",
		"樱"
	],
	"尨": [
		"尨",
		"狵"
	],
	"圈": [
		"圈",
		"圏"
	],
	"凶": [
		"凶",
		"兇"
	],
	"浜": [
		"浜",
		"濱",
		"滨"
	],
	"煙": [
		"煙",
		"烟",
		"菸"
	],
	"黒": [
		"黒",
		"黑"
	],
	"樂": [
		"樂",
		"乐",
		"楽"
	],
	"薬": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"劵": [
		"劵",
		"券",
		"卷"
	],
	"貳": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"隷": [
		"隷",
		"隸",
		"隶"
	],
	"姫": [
		"姫",
		"姬"
	],
	"薫": [
		"薫",
		"熏",
		"薰"
	],
	"籲": [
		"籲",
		"龥"
	],
	"齧": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"鹼": [
		"鹼",
		"碱",
		"硷"
	],
	"咸": [
		"咸",
		"鹹"
	],
	"穗": [
		"穗",
		"穂"
	],
	"廢": [
		"廢",
		"廃",
		"废"
	],
	"蹠": [
		"蹠",
		"跖"
	],
	"吒": [
		"吒",
		"咤"
	],
	"剷": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"擗": [
		"擗",
		"劈"
	],
	"核": [
		"核",
		"覈"
	],
	"脣": [
		"脣",
		"唇"
	],
	"升": [
		"升",
		"昇"
	],
	"磐": [
		"磐",
		"盤",
		"盘"
	],
	"溪": [
		"溪",
		"渓"
	],
	"谿": [
		"谿",
		"嵠"
	],
	"折": [
		"折",
		"摺"
	],
	"祐": [
		"祐",
		"佑"
	],
	"瓮": [
		"瓮",
		"罋",
		"甕"
	],
	"蹤": [
		"蹤",
		"踪",
		"踨"
	],
	"暗": [
		"闇",
		"暗"
	],
	"昵": [
		"昵",
		"暱"
	],
	"布": [
		"布",
		"佈"
	],
	"為": [
		"為",
		"为",
		"爲"
	],
	"綳": [
		"綳",
		"繃",
		"绷"
	],
	"痺": [
		"痺",
		"痹"
	],
	"痲": [
		"痲",
		"痳"
	],
	"雇": [
		"雇",
		"僱"
	],
	"敘": [
		"敘",
		"叙",
		"敍"
	],
	"盪": [
		"盪",
		"蕩",
		"荡"
	],
	"勛": [
		"勛",
		"勳",
		"勋",
		"勲"
	],
	"祕": [
		"祕",
		"秘"
	],
	"牆": [
		"牆",
		"墙",
		"墻"
	],
	"爾": [
		"爾",
		"尔",
		"尓"
	],
	"焰": [
		"焰",
		"焔"
	],
	"默": [
		"默",
		"黙"
	],
	"壓": [
		"壓",
		"压",
		"圧"
	],
	"廸": [
		"廸",
		"迪"
	],
	"曉": [
		"曉",
		"晓",
		"暁"
	],
	"霸": [
		"霸",
		"覇"
	],
	"霊": [
		"霊",
		"靈",
		"灵"
	],
	"泪": [
		"泪",
		"涙",
		"淚"
	],
	"牺": [
		"牺",
		"犠",
		"犧"
	],
	"藉": [
		"藉",
		"耤"
	],
	"噸": [
		"噸",
		"吨"
	],
	"俱": [
		"俱",
		"倶"
	],
	"粽": [
		"粽",
		"糉",
		"糭"
	],
	"向": [
		"向",
		"曏",
		"嚮"
	],
	"悽": [
		"悽",
		"淒",
		"凄"
	],
	"鱷": [
		"鱷",
		"鰐",
		"鳄"
	],
	"滷": [
		"滷",
		"鹵",
		"卤"
	],
	"颜": [
		"颜",
		"顏",
		"顔"
	],
	"衝": [
		"衝",
		"沖",
		"冲"
	],
	"樑": [
		"樑",
		"梁"
	],
	"砂": [
		"砂",
		"沙"
	],
	"炭": [
		"炭",
		"碳"
	],
	"糸": [
		"糸",
		"絲",
		"丝"
	],
	"簷": [
		"簷",
		"檐"
	],
	"涌": [
		"涌",
		"湧"
	],
	"糓": [
		"穀",
		"糓"
	],
	"両": [
		"両",
		"两",
		"兩"
	],
	"家": [
		"家",
		"傢"
	],
	"妳": [
		"妳",
		"你"
	],
	"她": [
		"她",
		"他"
	],
	"藤": [
		"藤",
		"籐",
		"籘"
	],
	"嬉": [
		"嬉",
		"嘻"
	],
	"亘": [
		"亘",
		"亙"
	],
	"恆": [
		"恆",
		"恒"
	],
	"鶇": [
		"鶇",
		"鶫",
		"鸫"
	],
	"姉": [
		"姉",
		"姐",
		"姊"
	],
	"剁": [
		"剁",
		"刴"
	],
	"泄": [
		"泄",
		"洩"
	],
	"舖": [
		"舖",
		"铺",
		"鋪",
		"舗"
	],
	"效": [
		"效",
		"効"
	],
	"喻": [
		"喻",
		"喩"
	],
	"插": [
		"挿",
		"插",
		"揷"
	],
	"銳": [
		"銳",
		"鋭",
		"锐"
	],
	"權": [
		"權",
		"権",
		"权"
	],
	"経": [
		"経",
		"經",
		"经"
	],
	"歓": [
		"歓",
		"歡",
		"欢"
	],
	"孃": [
		"嬢",
		"孃"
	],
	"済": [
		"済",
		"濟",
		"济"
	],
	"收": [
		"収",
		"收"
	],
	"綠": [
		"綠",
		"緑",
		"绿"
	],
	"唖": [
		"唖",
		"啞",
		"哑"
	],
	"剿": [
		"剿",
		"勦",
		"𠞰"
	],
	"禍": [
		"禍",
		"禍",
		"祸"
	],
	"営": [
		"營",
		"営",
		"营"
	],
	"産": [
		"產",
		"産",
		"产"
	],
	"査": [
		"查",
		"査"
	],
	"絵": [
		"繪",
		"絵",
		"绘"
	],
	"懐": [
		"懷",
		"懐",
		"怀"
	],
	"釈": [
		"釋",
		"釈",
		"释"
	],
	"蔵": [
		"藏",
		"蔵"
	],
	"娯": [
		"娛",
		"娯",
		"娱"
	],
	"焼": [
		"燒",
		"焼",
		"烧"
	],
	"拡": [
		"擴",
		"拡",
		"扩"
	],
	"賎": [
		"賤",
		"賎",
		"贱"
	],
	"銭": [
		"錢",
		"銭",
		"钱"
	],
	"雑": [
		"雜",
		"雑",
		"杂"
	],
	"聴": [
		"聽",
		"聴",
		"听"
	],
	"帯": [
		"帶",
		"帯",
		"带"
	],
	"閲": [
		"閲",
		"阅"
	],
	"覧": [
		"覽",
		"覧",
		"览"
	],
	"悪": [
		"惡",
		"悪",
		"恶"
	],
	"亜": [
		"亞",
		"亜",
		"亚"
	],
	"氷": [
		"冰",
		"氷"
	],
	"县": [
		"県",
		"縣",
		"县"
	],
	"肅": [
		"粛",
		"肅",
		"肃"
	],
	"専": [
		"專",
		"専",
		"专"
	],
	"様": [
		"樣",
		"様",
		"样"
	],
	"関": [
		"關",
		"関",
		"关"
	],
	"檢": [
		"検",
		"檢",
		"检"
	],
	"侮": [
		"侮",
		"侮"
	],
	"沉": [
		"沉",
		"沈"
	],
	"嚐": [
		"嚐",
		"嘗",
		"尝"
	],
	"搾": [
		"搾",
		"榨"
	],
	"获": [
		"获",
		"獲",
		"穫"
	],
	"繮": [
		"繮",
		"缰",
		"韁"
	],
	"贋": [
		"贋",
		"贗",
		"赝"
	],
	"獃": [
		"呆"
	],
	"杯": [
		"杯",
		"盃"
	],
	"呪": [
		"呪",
		"咒",
		"詋"
	],
	"䇳": [
		"䇳",
		"笺",
		"箋",
		"牋"
	],
	"竝": [
		"竝",
		"𠀤"
	],
	"彷": [
		"彷",
		"徬"
	],
	"贑": [
		"贑",
		"𫎬"
	],
	"崖": [
		"崖",
		"崕",
		"厓"
	],
	"岩": [
		"岩",
		"巖",
		"巗",
		"巌"
	],
	"灕": [
		"灕",
		"漓"
	],
	"粘": [
		"粘",
		"黏"
	],
	"娴": [
		"娴",
		"嫺",
		"嫻"
	],
	"哗": [
		"哗",
		"嘩",
		"譁"
	],
	"拔": [
		"拔",
		"抜"
	],
	"湿": [
		"湿",
		"溼",
		"濕"
	],
	"稻": [
		"稻",
		"稲"
	],
	"楕": [
		"楕",
		"椭",
		"橢"
	],
	"毎": [
		"毎",
		"每"
	],
	"篦": [
		"篦",
		"箆"
	],
	"騨": [
		"騨",
		"驒",
		"驔"
	],
	"猛": [
		"猛",
		"勐"
	],
	"吿": [
		"吿",
		"告"
	],
	"刃": [
		"刃",
		"刄"
	],
	"教": [
		"教",
		"敎"
	],
	"蛎": [
		"蛎",
		"蜊",
		"蠣"
	],
	"步": [
		"步",
		"歩"
	],
	"劫": [
		"刦",
		"刧",
		"刼",
		"劫"
	],
	"鎚": [
		"鎚",
		"錘",
		"锤"
	],
	"捶": [
		"搥"
	],
	"剑": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"剣": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"劎": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"劒": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"剱": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"劔": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"炮": [
		"砲",
		"炮"
	],
	"僞": [
		"偽",
		"僞"
	],
	"内": [
		"內",
		"内"
	],
	"鬭": [
		"鬭",
		"鬥",
		"闘",
		"鬪"
	],
	"闘": [
		"鬭",
		"鬥",
		"闘",
		"鬪"
	],
	"鬪": [
		"鬭",
		"鬥",
		"闘",
		"鬪"
	],
	"鷄": [
		"鶏",
		"鷄",
		"雞",
		"鸡"
	],
	"雞": [
		"鶏",
		"鷄",
		"雞",
		"鸡"
	],
	"鸡": [
		"鶏",
		"鷄",
		"雞",
		"鸡"
	],
	"兔": [
		"兎",
		"兔"
	],
	"坯": [
		"坯",
		"坏",
		"壊",
		"壞"
	],
	"壊": [
		"坯",
		"坏",
		"壊",
		"壞"
	],
	"壞": [
		"坯",
		"坏",
		"壊",
		"壞"
	],
	"殼": [
		"殻",
		"殼",
		"壳"
	],
	"壳": [
		"殻",
		"殼",
		"壳"
	],
	"象": [
		"像",
		"象"
	],
	"苏": [
		"苏",
		"蘇",
		"囌"
	],
	"囌": [
		"苏",
		"蘇",
		"囌"
	],
	"館": [
		"館",
		"館",
		"舘",
		"馆"
	],
	"舘": [
		"館",
		"館",
		"舘",
		"馆"
	],
	"馆": [
		"館",
		"館",
		"舘",
		"馆"
	],
	"鸟": [
		"鳥",
		"鸟",
		"𫠓"
	],
	"𫠓": [
		"鳥",
		"鸟",
		"𫠓"
	],
	"視": [
		"視",
		"視",
		"视",
		"眎"
	],
	"视": [
		"視",
		"視",
		"视",
		"眎"
	],
	"眎": [
		"視",
		"視",
		"视",
		"眎"
	],
	"險": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"险": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"嶮": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"崄": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"絕": [
		"絶",
		"絕",
		"绝"
	],
	"绝": [
		"絶",
		"絕",
		"绝"
	],
	"鐵": [
		"鉄",
		"鐵",
		"铁",
		"鐡"
	],
	"铁": [
		"鉄",
		"鐵",
		"铁",
		"鐡"
	],
	"鐡": [
		"鉄",
		"鐵",
		"铁",
		"鐡"
	],
	"諸": [
		"諸",
		"諸",
		"诸"
	],
	"诸": [
		"諸",
		"諸",
		"诸"
	],
	"寻": [
		"尋",
		"寻",
		"𡬶"
	],
	"𡬶": [
		"尋",
		"寻",
		"𡬶"
	],
	"裏": [
		"裡",
		"裏",
		"里"
	],
	"里": [
		"裡",
		"裏",
		"里"
	],
	"鉴": [
		"鑑",
		"鉴",
		"鑒"
	],
	"鑒": [
		"鑑",
		"鉴",
		"鑒"
	],
	"麪": [
		"麵",
		"麪",
		"麺"
	],
	"麺": [
		"麵",
		"麪",
		"麺"
	],
	"歳": [
		"歲",
		"歳",
		"岁"
	],
	"岁": [
		"歲",
		"歳",
		"岁"
	],
	"鍾": [
		"鐘",
		"鍾",
		"钟",
		"锺"
	],
	"钟": [
		"鐘",
		"鍾",
		"钟",
		"锺"
	],
	"锺": [
		"鐘",
		"鍾",
		"钟",
		"锺"
	],
	"会": [
		"會",
		"会",
		"㑹"
	],
	"㑹": [
		"會",
		"会",
		"㑹"
	],
	"凃": [
		"塗",
		"凃",
		"涂"
	],
	"涂": [
		"塗",
		"凃",
		"涂"
	],
	"髪": [
		"髮",
		"髪"
	],
	"话": [
		"話",
		"话",
		"䛡"
	],
	"䛡": [
		"話",
		"话",
		"䛡"
	],
	"阁": [
		"閤",
		"阁"
	],
	"參": [
		"蔘",
		"參",
		"参"
	],
	"参": [
		"蔘",
		"參",
		"参"
	],
	"勞": [
		"労",
		"勞",
		"劳"
	],
	"劳": [
		"労",
		"勞",
		"劳"
	],
	"囯": [
		"国",
		"囯",
		"國"
	],
	"國": [
		"国",
		"囯",
		"國"
	],
	"骂": [
		"罵",
		"骂",
		"駡"
	],
	"駡": [
		"罵",
		"骂",
		"駡"
	],
	"對": [
		"対",
		"對",
		"对"
	],
	"对": [
		"対",
		"對",
		"对"
	],
	"銹": [
		"鏽",
		"銹",
		"锈"
	],
	"锈": [
		"鏽",
		"銹",
		"锈"
	],
	"䭾": [
		"駄",
		"䭾",
		"馱",
		"驮"
	],
	"馱": [
		"駄",
		"䭾",
		"馱",
		"驮"
	],
	"驮": [
		"駄",
		"䭾",
		"馱",
		"驮"
	],
	"萨": [
		"薩",
		"萨",
		"蕯"
	],
	"蕯": [
		"薩",
		"萨",
		"蕯"
	],
	"單": [
		"単",
		"單",
		"单"
	],
	"单": [
		"単",
		"單",
		"单"
	],
	"繼": [
		"継",
		"繼",
		"继"
	],
	"继": [
		"継",
		"繼",
		"继"
	],
	"验": [
		"驗",
		"验",
		"騐",
		"験"
	],
	"騐": [
		"驗",
		"验",
		"騐",
		"験"
	],
	"験": [
		"驗",
		"验",
		"騐",
		"験"
	],
	"歷": [
		"歴",
		"歷"
	],
	"曆": [
		"暦",
		"曆"
	],
	"团": [
		"团",
		"団",
		"團"
	],
	"團": [
		"团",
		"団",
		"團"
	],
	"麽": [
		"麼",
		"麽",
		"庅"
	],
	"庅": [
		"麼",
		"麽",
		"庅"
	],
	"戦": [
		"戦",
		"戰",
		"战"
	],
	"战": [
		"戦",
		"戰",
		"战"
	],
	"郷": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"鄕": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"鄉": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"鄊": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"勉": [
		"勉",
		"勉"
	],
	"馀": [
		"餘",
		"馀",
		"余"
	],
	"余": [
		"餘",
		"馀",
		"余"
	],
	"䋄": [
		"網",
		"䋄",
		"䋞",
		"网"
	],
	"䋞": [
		"網",
		"䋄",
		"䋞",
		"网"
	],
	"网": [
		"網",
		"䋄",
		"䋞",
		"网"
	],
	"讬": [
		"託",
		"讬",
		"托"
	],
	"托": [
		"託",
		"讬",
		"托"
	],
	"纤": [
		"纖",
		"纤",
		"縴",
		"繊"
	],
	"縴": [
		"纖",
		"纤",
		"縴",
		"繊"
	],
	"繊": [
		"纖",
		"纤",
		"縴",
		"繊"
	],
	"錬": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"𫔀": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"炼": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"煉": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"撃": [
		"撃",
		"擊",
		"击"
	],
	"击": [
		"撃",
		"擊",
		"击"
	],
	"実": [
		"實",
		"実",
		"实",
		"寔"
	],
	"实": [
		"實",
		"実",
		"实",
		"寔"
	],
	"寔": [
		"實",
		"実",
		"实",
		"寔"
	],
	"扵": [
		"於",
		"扵"
	],
	"証": [
		"證",
		"証",
		"证"
	],
	"证": [
		"證",
		"証",
		"证"
	],
	"据": [
		"據",
		"据",
		"拠"
	],
	"拠": [
		"據",
		"据",
		"拠"
	],
	"处": [
		"處",
		"处",
		"䖏",
		"処"
	],
	"䖏": [
		"處",
		"处",
		"䖏",
		"処"
	],
	"処": [
		"處",
		"处",
		"䖏",
		"処"
	],
	"瞠": [
		"瞪",
		"瞠",
		"眙"
	],
	"眙": [
		"瞪",
		"瞠",
		"眙"
	],
	"胑": [
		"肢",
		"胑"
	],
	"宍": [
		"肉",
		"宍",
		"𠕎"
	],
	"𠕎": [
		"肉",
		"宍",
		"𠕎"
	],
	"𢝊": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"𢚧": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"𢟜": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"懮": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"𨗫": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"繋": [
		"繫",
		"繋"
	],
	"迴": [
		"廻",
		"迴"
	],
	"錄": [
		"録",
		"錄",
		"录"
	],
	"录": [
		"録",
		"錄",
		"录"
	],
	"槍": [
		"鎗",
		"槍",
		"枪"
	],
	"枪": [
		"鎗",
		"槍",
		"枪"
	],
	"滺": [
		"悠",
		"滺"
	],
	"壺": [
		"壶",
		"壺",
		"壷"
	],
	"壷": [
		"壶",
		"壺",
		"壷"
	],
	"兹": [
		"茲",
		"兹",
		"玆"
	],
	"玆": [
		"茲",
		"兹",
		"玆"
	],
	"盖": [
		"蓋",
		"盖",
		"葢"
	],
	"葢": [
		"蓋",
		"盖",
		"葢"
	],
	"跡": [
		"蹟",
		"跡",
		"迹"
	],
	"迹": [
		"蹟",
		"跡",
		"迹"
	],
	"瘉": [
		"癒",
		"瘉"
	],
	"邊": [
		"辺",
		"邊",
		"边",
		"邉"
	],
	"边": [
		"辺",
		"邊",
		"边",
		"邉"
	],
	"邉": [
		"辺",
		"邊",
		"边",
		"邉"
	],
	"凖": [
		"準",
		"凖"
	],
	"衞": [
		"衛",
		"衞",
		"卫"
	],
	"卫": [
		"衛",
		"衞",
		"卫"
	],
	"晩": [
		"晚",
		"晩"
	],
	"躶": [
		"裸",
		"躶"
	],
	"龜": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"龟": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"𪚧": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"𪚿": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"𠃾": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"氹": [
		"凼",
		"氹"
	],
	"草": [
		"艸",
		"草"
	],
	"剳": [
		"箚",
		"剳"
	],
	"復": [
		"复",
		"復",
		"複"
	],
	"複": [
		"复",
		"復",
		"複"
	],
	"汙": [
		"污",
		"汙",
		"汚"
	],
	"汚": [
		"污",
		"汙",
		"汚"
	],
	"夥": [
		"伙",
		"夥"
	],
	"禦": [
		"御",
		"禦"
	],
	"郁": [
		"鬱",
		"郁"
	],
	"凌": [
		"淩",
		"凌"
	],
	"扎": [
		"紮",
		"扎"
	],
	"癡": [
		"痴",
		"癡"
	],
	"棲": [
		"栖",
		"棲"
	],
	"奔": [
		"犇",
		"奔"
	],
	"范": [
		"範",
		"范"
	],
	"姜": [
		"薑",
		"姜",
		"葁"
	],
	"葁": [
		"薑",
		"姜",
		"葁"
	],
	"朴": [
		"樸",
		"朴"
	],
	"谘": [
		"諮",
		"谘",
		"咨"
	],
	"咨": [
		"諮",
		"谘",
		"咨"
	],
	"捻": [
		"撚",
		"捻"
	],
	"餵": [
		"喂",
		"餵",
		"餧",
		"𫗭"
	],
	"餧": [
		"喂",
		"餵",
		"餧",
		"𫗭"
	],
	"𫗭": [
		"喂",
		"餵",
		"餧",
		"𫗭"
	],
	"凈": [
		"淨",
		"凈",
		"净"
	],
	"净": [
		"淨",
		"凈",
		"净"
	],
	"慄": [
		"栗",
		"慄"
	],
	"輓": [
		"挽",
		"輓"
	],
	"竈": [
		"灶",
		"竈"
	],
	"缐": [
		"線",
		"缐",
		"綫",
		"线"
	],
	"綫": [
		"線",
		"缐",
		"綫",
		"线"
	],
	"线": [
		"線",
		"缐",
		"綫",
		"线"
	],
	"尽": [
		"盡",
		"尽",
		"儘"
	],
	"儘": [
		"盡",
		"尽",
		"儘"
	],
	"霉": [
		"黴",
		"霉"
	],
	"週": [
		"周",
		"週"
	],
	"并": [
		"並",
		"并",
		"併"
	],
	"併": [
		"並",
		"并",
		"併"
	],
	"讃": [
		"讚",
		"讃"
	],
	"觀": [
		"観",
		"觀",
		"观",
		"覌"
	],
	"观": [
		"観",
		"觀",
		"观",
		"覌"
	],
	"覌": [
		"観",
		"觀",
		"观",
		"覌"
	],
	"游": [
		"遊",
		"游"
	],
	"啓": [
		"启",
		"啓",
		"啟",
		"啔"
	],
	"啟": [
		"启",
		"啓",
		"啟",
		"啔"
	],
	"啔": [
		"启",
		"啓",
		"啟",
		"啔"
	],
	"厩": [
		"廄",
		"厩",
		"廐",
		"廏"
	],
	"廐": [
		"廄",
		"厩",
		"廐",
		"廏"
	],
	"廏": [
		"廄",
		"厩",
		"廐",
		"廏"
	],
	"気": [
		"気",
		"氣",
		"气"
	],
	"气": [
		"気",
		"氣",
		"气"
	],
	"慾": [
		"慾",
		"欲"
	],
	"杰": [
		"傑",
		"杰"
	],
	"锻": [
		"鍛",
		"锻",
		"煅"
	],
	"煅": [
		"鍛",
		"锻",
		"煅"
	],
	"徴": [
		"徵",
		"徴"
	],
	"𫔮": [
		"閒",
		"𫔮",
		"閑",
		"闲"
	],
	"閑": [
		"閒",
		"𫔮",
		"閑",
		"闲"
	],
	"闲": [
		"閒",
		"𫔮",
		"閑",
		"闲"
	],
	"赞": [
		"贊",
		"赞",
		"賛"
	],
	"賛": [
		"贊",
		"赞",
		"賛"
	],
	"桜": [
		"櫻",
		"桜",
		"樱"
	],
	"樱": [
		"櫻",
		"桜",
		"樱"
	],
	"狵": [
		"尨",
		"狵"
	],
	"圏": [
		"圈",
		"圏"
	],
	"兇": [
		"凶",
		"兇"
	],
	"濱": [
		"浜",
		"濱",
		"滨"
	],
	"滨": [
		"浜",
		"濱",
		"滨"
	],
	"烟": [
		"煙",
		"烟",
		"菸"
	],
	"菸": [
		"煙",
		"烟",
		"菸"
	],
	"黑": [
		"黒",
		"黑"
	],
	"乐": [
		"樂",
		"乐",
		"楽"
	],
	"楽": [
		"樂",
		"乐",
		"楽"
	],
	"藥": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"药": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"葯": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"𣛙": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"券": [
		"劵",
		"券",
		"卷"
	],
	"卷": [
		"劵",
		"券",
		"卷"
	],
	"贰": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"弐": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"貮": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"𢎐": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"二": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"隸": [
		"隷",
		"隸",
		"隶"
	],
	"隶": [
		"隷",
		"隸",
		"隶"
	],
	"姬": [
		"姫",
		"姬"
	],
	"熏": [
		"薫",
		"熏",
		"薰"
	],
	"薰": [
		"薫",
		"熏",
		"薰"
	],
	"龥": [
		"籲",
		"龥"
	],
	"啮": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"𪘂": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"囓": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"噛": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"嚙": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"碱": [
		"鹼",
		"碱",
		"硷"
	],
	"硷": [
		"鹼",
		"碱",
		"硷"
	],
	"鹹": [
		"咸",
		"鹹"
	],
	"穂": [
		"穗",
		"穂"
	],
	"廃": [
		"廢",
		"廃",
		"废"
	],
	"废": [
		"廢",
		"廃",
		"废"
	],
	"跖": [
		"蹠",
		"跖"
	],
	"咤": [
		"吒",
		"咤"
	],
	"鏟": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"铲": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"刬": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"剗": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"劈": [
		"擗",
		"劈"
	],
	"覈": [
		"核",
		"覈"
	],
	"唇": [
		"脣",
		"唇"
	],
	"昇": [
		"升",
		"昇"
	],
	"盤": [
		"磐",
		"盤",
		"盘"
	],
	"盘": [
		"磐",
		"盤",
		"盘"
	],
	"渓": [
		"溪",
		"渓"
	],
	"嵠": [
		"谿",
		"嵠"
	],
	"摺": [
		"折",
		"摺"
	],
	"佑": [
		"祐",
		"佑"
	],
	"罋": [
		"瓮",
		"罋",
		"甕"
	],
	"甕": [
		"瓮",
		"罋",
		"甕"
	],
	"踪": [
		"蹤",
		"踪",
		"踨"
	],
	"踨": [
		"蹤",
		"踪",
		"踨"
	],
	"闇": [
		"闇",
		"暗"
	],
	"暱": [
		"昵",
		"暱"
	],
	"佈": [
		"布",
		"佈"
	],
	"为": [
		"為",
		"为",
		"爲"
	],
	"爲": [
		"為",
		"为",
		"爲"
	],
	"繃": [
		"綳",
		"繃",
		"绷"
	],
	"绷": [
		"綳",
		"繃",
		"绷"
	],
	"痹": [
		"痺",
		"痹"
	],
	"痳": [
		"痲",
		"痳"
	],
	"僱": [
		"雇",
		"僱"
	],
	"叙": [
		"敘",
		"叙",
		"敍"
	],
	"敍": [
		"敘",
		"叙",
		"敍"
	],
	"蕩": [
		"盪",
		"蕩",
		"荡"
	],
	"荡": [
		"盪",
		"蕩",
		"荡"
	],
	"勳": [
		"勛",
		"勳",
		"勋",
		"勲"
	],
	"勋": [
		"勛",
		"勳",
		"勋",
		"勲"
	],
	"勲": [
		"勛",
		"勳",
		"勋",
		"勲"
	],
	"秘": [
		"祕",
		"秘"
	],
	"墙": [
		"牆",
		"墙",
		"墻"
	],
	"墻": [
		"牆",
		"墙",
		"墻"
	],
	"尔": [
		"爾",
		"尔",
		"尓"
	],
	"尓": [
		"爾",
		"尔",
		"尓"
	],
	"焔": [
		"焰",
		"焔"
	],
	"黙": [
		"默",
		"黙"
	],
	"压": [
		"壓",
		"压",
		"圧"
	],
	"圧": [
		"壓",
		"压",
		"圧"
	],
	"迪": [
		"廸",
		"迪"
	],
	"晓": [
		"曉",
		"晓",
		"暁"
	],
	"暁": [
		"曉",
		"晓",
		"暁"
	],
	"覇": [
		"霸",
		"覇"
	],
	"靈": [
		"霊",
		"靈",
		"灵"
	],
	"灵": [
		"霊",
		"靈",
		"灵"
	],
	"涙": [
		"泪",
		"涙",
		"淚"
	],
	"淚": [
		"泪",
		"涙",
		"淚"
	],
	"犠": [
		"牺",
		"犠",
		"犧"
	],
	"犧": [
		"牺",
		"犠",
		"犧"
	],
	"耤": [
		"藉",
		"耤"
	],
	"吨": [
		"噸",
		"吨"
	],
	"倶": [
		"俱",
		"倶"
	],
	"糉": [
		"粽",
		"糉",
		"糭"
	],
	"糭": [
		"粽",
		"糉",
		"糭"
	],
	"曏": [
		"向",
		"曏",
		"嚮"
	],
	"嚮": [
		"向",
		"曏",
		"嚮"
	],
	"淒": [
		"悽",
		"淒",
		"凄"
	],
	"凄": [
		"悽",
		"淒",
		"凄"
	],
	"鰐": [
		"鱷",
		"鰐",
		"鳄"
	],
	"鳄": [
		"鱷",
		"鰐",
		"鳄"
	],
	"鹵": [
		"滷",
		"鹵",
		"卤"
	],
	"卤": [
		"滷",
		"鹵",
		"卤"
	],
	"顏": [
		"颜",
		"顏",
		"顔"
	],
	"顔": [
		"颜",
		"顏",
		"顔"
	],
	"沖": [
		"衝",
		"沖",
		"冲"
	],
	"冲": [
		"衝",
		"沖",
		"冲"
	],
	"梁": [
		"樑",
		"梁"
	],
	"沙": [
		"砂",
		"沙"
	],
	"碳": [
		"炭",
		"碳"
	],
	"絲": [
		"糸",
		"絲",
		"丝"
	],
	"丝": [
		"糸",
		"絲",
		"丝"
	],
	"檐": [
		"簷",
		"檐"
	],
	"湧": [
		"涌",
		"湧"
	],
	"穀": [
		"穀",
		"糓"
	],
	"两": [
		"両",
		"两",
		"兩"
	],
	"兩": [
		"両",
		"两",
		"兩"
	],
	"傢": [
		"家",
		"傢"
	],
	"你": [
		"妳",
		"你"
	],
	"他": [
		"她",
		"他"
	],
	"籐": [
		"藤",
		"籐",
		"籘"
	],
	"籘": [
		"藤",
		"籐",
		"籘"
	],
	"嘻": [
		"嬉",
		"嘻"
	],
	"亙": [
		"亘",
		"亙"
	],
	"恒": [
		"恆",
		"恒"
	],
	"鶫": [
		"鶇",
		"鶫",
		"鸫"
	],
	"鸫": [
		"鶇",
		"鶫",
		"鸫"
	],
	"姐": [
		"姉",
		"姐",
		"姊"
	],
	"姊": [
		"姉",
		"姐",
		"姊"
	],
	"刴": [
		"剁",
		"刴"
	],
	"洩": [
		"泄",
		"洩"
	],
	"铺": [
		"舖",
		"铺",
		"鋪",
		"舗"
	],
	"鋪": [
		"舖",
		"铺",
		"鋪",
		"舗"
	],
	"舗": [
		"舖",
		"铺",
		"鋪",
		"舗"
	],
	"効": [
		"效",
		"効"
	],
	"喩": [
		"喻",
		"喩"
	],
	"挿": [
		"挿",
		"插",
		"揷"
	],
	"揷": [
		"挿",
		"插",
		"揷"
	],
	"鋭": [
		"銳",
		"鋭",
		"锐"
	],
	"锐": [
		"銳",
		"鋭",
		"锐"
	],
	"権": [
		"權",
		"権",
		"权"
	],
	"权": [
		"權",
		"権",
		"权"
	],
	"經": [
		"経",
		"經",
		"经"
	],
	"经": [
		"経",
		"經",
		"经"
	],
	"歡": [
		"歓",
		"歡",
		"欢"
	],
	"欢": [
		"歓",
		"歡",
		"欢"
	],
	"嬢": [
		"嬢",
		"孃"
	],
	"濟": [
		"済",
		"濟",
		"济"
	],
	"济": [
		"済",
		"濟",
		"济"
	],
	"収": [
		"収",
		"收"
	],
	"緑": [
		"綠",
		"緑",
		"绿"
	],
	"绿": [
		"綠",
		"緑",
		"绿"
	],
	"啞": [
		"唖",
		"啞",
		"哑"
	],
	"哑": [
		"唖",
		"啞",
		"哑"
	],
	"勦": [
		"剿",
		"勦",
		"𠞰"
	],
	"𠞰": [
		"剿",
		"勦",
		"𠞰"
	],
	"禍": [
		"禍",
		"禍",
		"祸"
	],
	"祸": [
		"禍",
		"禍",
		"祸"
	],
	"營": [
		"營",
		"営",
		"营"
	],
	"营": [
		"營",
		"営",
		"营"
	],
	"產": [
		"產",
		"産",
		"产"
	],
	"产": [
		"產",
		"産",
		"产"
	],
	"查": [
		"查",
		"査"
	],
	"繪": [
		"繪",
		"絵",
		"绘"
	],
	"绘": [
		"繪",
		"絵",
		"绘"
	],
	"懷": [
		"懷",
		"懐",
		"怀"
	],
	"怀": [
		"懷",
		"懐",
		"怀"
	],
	"釋": [
		"釋",
		"釈",
		"释"
	],
	"释": [
		"釋",
		"釈",
		"释"
	],
	"藏": [
		"藏",
		"蔵"
	],
	"娛": [
		"娛",
		"娯",
		"娱"
	],
	"娱": [
		"娛",
		"娯",
		"娱"
	],
	"燒": [
		"燒",
		"焼",
		"烧"
	],
	"烧": [
		"燒",
		"焼",
		"烧"
	],
	"擴": [
		"擴",
		"拡",
		"扩"
	],
	"扩": [
		"擴",
		"拡",
		"扩"
	],
	"賤": [
		"賤",
		"賎",
		"贱"
	],
	"贱": [
		"賤",
		"賎",
		"贱"
	],
	"錢": [
		"錢",
		"銭",
		"钱"
	],
	"钱": [
		"錢",
		"銭",
		"钱"
	],
	"雜": [
		"雜",
		"雑",
		"杂"
	],
	"杂": [
		"雜",
		"雑",
		"杂"
	],
	"聽": [
		"聽",
		"聴",
		"听"
	],
	"听": [
		"聽",
		"聴",
		"听"
	],
	"帶": [
		"帶",
		"帯",
		"带"
	],
	"带": [
		"帶",
		"帯",
		"带"
	],
	"阅": [
		"閲",
		"阅"
	],
	"覽": [
		"覽",
		"覧",
		"览"
	],
	"览": [
		"覽",
		"覧",
		"览"
	],
	"惡": [
		"惡",
		"悪",
		"恶"
	],
	"恶": [
		"惡",
		"悪",
		"恶"
	],
	"亞": [
		"亞",
		"亜",
		"亚"
	],
	"亚": [
		"亞",
		"亜",
		"亚"
	],
	"冰": [
		"冰",
		"氷"
	],
	"県": [
		"県",
		"縣",
		"县"
	],
	"縣": [
		"県",
		"縣",
		"县"
	],
	"粛": [
		"粛",
		"肅",
		"肃"
	],
	"肃": [
		"粛",
		"肅",
		"肃"
	],
	"專": [
		"專",
		"専",
		"专"
	],
	"专": [
		"專",
		"専",
		"专"
	],
	"樣": [
		"樣",
		"様",
		"样"
	],
	"样": [
		"樣",
		"様",
		"样"
	],
	"關": [
		"關",
		"関",
		"关"
	],
	"关": [
		"關",
		"関",
		"关"
	],
	"検": [
		"検",
		"檢",
		"检"
	],
	"检": [
		"検",
		"檢",
		"检"
	],
	"侮": [
		"侮",
		"侮"
	],
	"沈": [
		"沉",
		"沈"
	],
	"嘗": [
		"嚐",
		"嘗",
		"尝"
	],
	"尝": [
		"嚐",
		"嘗",
		"尝"
	],
	"榨": [
		"搾",
		"榨"
	],
	"獲": [
		"获",
		"獲",
		"穫"
	],
	"穫": [
		"获",
		"獲",
		"穫"
	],
	"缰": [
		"繮",
		"缰",
		"韁"
	],
	"韁": [
		"繮",
		"缰",
		"韁"
	],
	"贗": [
		"贋",
		"贗",
		"赝"
	],
	"赝": [
		"贋",
		"贗",
		"赝"
	],
	"呆": [
		"呆"
	],
	"盃": [
		"杯",
		"盃"
	],
	"咒": [
		"呪",
		"咒",
		"詋"
	],
	"詋": [
		"呪",
		"咒",
		"詋"
	],
	"笺": [
		"䇳",
		"笺",
		"箋",
		"牋"
	],
	"箋": [
		"䇳",
		"笺",
		"箋",
		"牋"
	],
	"牋": [
		"䇳",
		"笺",
		"箋",
		"牋"
	],
	"𠀤": [
		"竝",
		"𠀤"
	],
	"徬": [
		"彷",
		"徬"
	],
	"𫎬": [
		"贑",
		"𫎬"
	],
	"崕": [
		"崖",
		"崕",
		"厓"
	],
	"厓": [
		"崖",
		"崕",
		"厓"
	],
	"巖": [
		"岩",
		"巖",
		"巗",
		"巌"
	],
	"巗": [
		"岩",
		"巖",
		"巗",
		"巌"
	],
	"巌": [
		"岩",
		"巖",
		"巗",
		"巌"
	],
	"漓": [
		"灕",
		"漓"
	],
	"黏": [
		"粘",
		"黏"
	],
	"嫺": [
		"娴",
		"嫺",
		"嫻"
	],
	"嫻": [
		"娴",
		"嫺",
		"嫻"
	],
	"嘩": [
		"哗",
		"嘩",
		"譁"
	],
	"譁": [
		"哗",
		"嘩",
		"譁"
	],
	"抜": [
		"拔",
		"抜"
	],
	"溼": [
		"湿",
		"溼",
		"濕"
	],
	"濕": [
		"湿",
		"溼",
		"濕"
	],
	"稲": [
		"稻",
		"稲"
	],
	"椭": [
		"楕",
		"椭",
		"橢"
	],
	"橢": [
		"楕",
		"椭",
		"橢"
	],
	"每": [
		"毎",
		"每"
	],
	"箆": [
		"篦",
		"箆"
	],
	"驒": [
		"騨",
		"驒",
		"驔"
	],
	"驔": [
		"騨",
		"驒",
		"驔"
	],
	"勐": [
		"猛",
		"勐"
	],
	"告": [
		"吿",
		"告"
	],
	"刄": [
		"刃",
		"刄"
	],
	"敎": [
		"教",
		"敎"
	],
	"蜊": [
		"蛎",
		"蜊",
		"蠣"
	],
	"蠣": [
		"蛎",
		"蜊",
		"蠣"
	],
	"歩": [
		"步",
		"歩"
	],
	"刦": [
		"刦",
		"刧",
		"刼",
		"劫"
	],
	"刧": [
		"刦",
		"刧",
		"刼",
		"劫"
	],
	"刼": [
		"刦",
		"刧",
		"刼",
		"劫"
	],
	"錘": [
		"鎚",
		"錘",
		"锤"
	],
	"锤": [
		"鎚",
		"錘",
		"锤"
	],
	"搥": [
		"搥"
	]
};

export type ITableJpKeys = "と" | "の" | "罗" | "會" | "会" | "㑹" | "䇳" | "笺" | "箋" | "牋" | "網" | "䋄" | "䋞" | "网" | "處" | "处" | "䖏" | "処" | "話" | "话" | "䛡" | "駄" | "䭾" | "馱" | "驮" | "専" | "專" | "专" | "糸" | "絲" | "丝" | "両" | "两" | "兩" | "併" | "并" | "並" | "為" | "为" | "爲" | "麼" | "麽" | "樂" | "乐" | "楽" | "乡" | "郷" | "鄕" | "鄉" | "鄊" | "乾" | "亁" | "乹" | "干" | "亀" | "龜" | "龟" | "𪚧" | "𪚿" | "𠃾" | "貳" | "贰" | "弐" | "貮" | "𢎐" | "二" | "於" | "亘" | "亙" | "亜" | "亞" | "亚" | "産" | "產" | "产" | "她" | "他" | "伙" | "夥" | "偽" | "僞" | "布" | "佈" | "祐" | "佑" | "餘" | "馀" | "余" | "妳" | "你" | "倂" | "儘" | "侭" | "侮" | "侮" | "修" | "俱" | "倶" | "藉" | "媮" | "傑" | "杰" | "家" | "傢" | "像" | "象" | "雇" | "僱" | "当" | "儓" | "檯" | "盡" | "尽" | "忧" | "凶" | "兇" | "勉" | "勉" | "兎" | "兔" | "內" | "内" | "関" | "關" | "关" | "茲" | "兹" | "玆" | "氷" | "冰" | "冲" | "衝" | "沖" | "淨" | "凈" | "净" | "塗" | "凃" | "涂" | "悽" | "淒" | "凄" | "准" | "準" | "淩" | "凌" | "凖" | "擊" | "撃" | "击" | "凼" | "氹" | "刃" | "刄" | "画" | "瀏" | "浏" | "劫" | "刦" | "刧" | "刼" | "剷" | "鏟" | "铲" | "刬" | "剗" | "剁" | "刴" | "卷" | "巻" | "劵" | "券" | "劍" | "剑" | "剣" | "劎" | "劒" | "剱" | "劔" | "箚" | "剳" | "剿" | "勦" | "𠞰" | "擗" | "劈" | "労" | "勞" | "劳" | "效" | "効" | "勛" | "勳" | "勋" | "勲" | "猛" | "勐" | "汇" | "升" | "昇" | "単" | "單" | "单" | "滷" | "鹵" | "卤" | "衛" | "衞" | "卫" | "捲" | "历" | "歴" | "歷" | "暦" | "曆" | "壓" | "压" | "圧" | "崖" | "崕" | "厓" | "廄" | "厩" | "廐" | "廏" | "县" | "県" | "縣" | "蔘" | "參" | "参" | "收" | "収" | "发" | "髮" | "敘" | "叙" | "敍" | "台" | "吁" | "閤" | "阁" | "向" | "曏" | "嚮" | "吒" | "咤" | "噸" | "吨" | "聴" | "聽" | "听" | "启" | "啓" | "啟" | "啔" | "吿" | "告" | "獃" | "呆" | "周" | "週" | "呪" | "咒" | "詋" | "嗬" | "呻" | "唿" | "諮" | "谘" | "咨" | "鹹" | "咸" | "唖" | "啞" | "哑" | "哗" | "嘩" | "譁" | "脣" | "唇" | "齧" | "啮" | "𪘂" | "囓" | "噛" | "嚙" | "囉" | "啰" | "喂" | "餵" | "餧" | "𫗭" | "喻" | "喩" | "営" | "營" | "营" | "嚐" | "嘗" | "尝" | "嬉" | "嘻" | "恶" | "苏" | "蘇" | "囌" | "廻" | "迴" | "団" | "团" | "團" | "国" | "囯" | "國" | "図" | "圈" | "圏" | "坏" | "坯" | "壊" | "壞" | "牆" | "墙" | "墻" | "殻" | "殼" | "壳" | "壶" | "壺" | "壷" | "覆" | "复" | "復" | "複" | "犇" | "奔" | "姉" | "姐" | "姊" | "薑" | "姜" | "葁" | "姫" | "姬" | "孃" | "嬢" | "娯" | "娛" | "娱" | "娴" | "嫺" | "嫻" | "肉" | "宍" | "𠕎" | "實" | "実" | "实" | "寔" | "祕" | "秘" | "対" | "對" | "对" | "尋" | "寻" | "𡬶" | "爾" | "尔" | "尓" | "尨" | "狵" | "歲" | "歳" | "岁" | "岩" | "巖" | "巗" | "巌" | "険" | "險" | "险" | "嶮" | "崄" | "谿" | "嵠" | "帯" | "帶" | "带" | "幹" | "幷" | "庅" | "廢" | "廃" | "废" | "廸" | "迪" | "犟" | "録" | "錄" | "录" | "彩" | "彷" | "徬" | "徵" | "徴" | "御" | "禦" | "憂" | "懐" | "懷" | "怀" | "恆" | "恒" | "悪" | "惡" | "悠" | "滺" | "癒" | "瘉" | "栗" | "慄" | "慾" | "欲" | "𢝊" | "𢚧" | "𢟜" | "懮" | "𨗫" | "懞" | "戰" | "戦" | "战" | "紮" | "扎" | "託" | "讬" | "托" | "拡" | "擴" | "扩" | "扵" | "折" | "摺" | "拔" | "抜" | "據" | "据" | "拠" | "挽" | "輓" | "插" | "挿" | "揷" | "捶" | "撚" | "捻" | "采" | "揹" | "搥" | "搾" | "榨" | "教" | "敎" | "闘" | "鬥" | "鬭" | "鬪" | "昵" | "暱" | "曉" | "晓" | "暁" | "晚" | "晩" | "闇" | "暗" | "樸" | "朴" | "雑" | "雜" | "杂" | "權" | "権" | "权" | "杯" | "盃" | "版" | "鎗" | "槍" | "枪" | "査" | "查" | "栖" | "棲" | "様" | "樣" | "样" | "核" | "覈" | "櫻" | "桜" | "樱" | "樑" | "梁" | "檢" | "検" | "检" | "楕" | "椭" | "橢" | "簷" | "檐" | "歓" | "歡" | "欢" | "步" | "歩" | "毎" | "每" | "氣" | "気" | "气" | "污" | "汙" | "汚" | "沉" | "沈" | "砂" | "沙" | "泄" | "洩" | "泪" | "涙" | "淚" | "済" | "濟" | "济" | "浜" | "濱" | "滨" | "涌" | "湧" | "溪" | "渓" | "遊" | "游" | "湿" | "溼" | "濕" | "灕" | "漓" | "濛" | "霊" | "靈" | "灵" | "灶" | "竈" | "炭" | "碳" | "炰" | "砲" | "炮" | "練" | "练" | "鍊" | "錬" | "𫔀" | "炼" | "煉" | "煙" | "烟" | "菸" | "焼" | "燒" | "烧" | "焰" | "焔" | "鍛" | "锻" | "煅" | "煇" | "𪸩" | "燻" | "薫" | "熏" | "薰" | "牺" | "犠" | "犧" | "获" | "獲" | "穫" | "瓮" | "罋" | "甕" | "甦" | "痲" | "痳" | "痴" | "癡" | "痺" | "痹" | "蓋" | "盖" | "葢" | "磐" | "盤" | "盘" | "盪" | "蕩" | "荡" | "視" | "視" | "视" | "眎" | "瞪" | "瞠" | "眙" | "矇" | "鹼" | "碱" | "硷" | "袮" | "禍" | "禍" | "祸" | "稻" | "稲" | "糓" | "穀" | "穗" | "穂" | "竝" | "𠀤" | "签" | "篦" | "箆" | "範" | "范" | "藤" | "籐" | "籘" | "籲" | "龥" | "粘" | "黏" | "肅" | "粛" | "肃" | "粽" | "糉" | "糭" | "繫" | "繋" | "経" | "經" | "经" | "絶" | "絕" | "绝" | "絵" | "繪" | "绘" | "継" | "繼" | "继" | "綠" | "緑" | "绿" | "線" | "缐" | "綫" | "线" | "綳" | "繃" | "绷" | "纖" | "纤" | "縴" | "繊" | "繮" | "缰" | "韁" | "罵" | "骂" | "駡" | "耤" | "肢" | "胑" | "脏" | "舖" | "铺" | "鋪" | "舗" | "館" | "館" | "舘" | "馆" | "艸" | "草" | "薬" | "藥" | "药" | "葯" | "𣛙" | "薩" | "萨" | "蕯" | "蔵" | "藏" | "蛎" | "蜊" | "蠣" | "裡" | "裏" | "里" | "裸" | "躶" | "霸" | "覇" | "観" | "觀" | "观" | "覌" | "覧" | "覽" | "览" | "證" | "証" | "证" | "諸" | "諸" | "诸" | "讚" | "讃" | "賎" | "賤" | "贱" | "贊" | "赞" | "賛" | "贋" | "贗" | "赝" | "贑" | "𫎬" | "蹠" | "跖" | "蹟" | "跡" | "迹" | "蹤" | "踪" | "踨" | "辟" | "避" | "闢" | "辺" | "邊" | "边" | "邉" | "鬱" | "郁" | "釈" | "釋" | "释" | "𠩺" | "鉄" | "鐵" | "铁" | "鐡" | "鑑" | "鉴" | "鑒" | "銭" | "錢" | "钱" | "銳" | "鋭" | "锐" | "鏽" | "銹" | "锈" | "鎚" | "錘" | "锤" | "鐘" | "鍾" | "钟" | "锺" | "閒" | "𫔮" | "閑" | "闲" | "閲" | "阅" | "隷" | "隸" | "隶" | "鶏" | "鷄" | "雞" | "鸡" | "黴" | "霉" | "面" | "麵" | "麪" | "鬚" | "颜" | "顏" | "顔" | "驗" | "验" | "騐" | "験" | "騨" | "驒" | "驔" | "髪" | "鱷" | "鰐" | "鳄" | "鳥" | "鸟" | "𫠓" | "鶇" | "鶫" | "鸫" | "麺" | "黒" | "黑" | "默" | "黙"

/**
 * 此表內只有符合 KEY 值時才會觸發
 */
export const table_jp: Record<ITableJpKeys, string[]> = {
	"の": [
		"の",
		"之",
		"的"
	],
	"と": [
		"と",
		"與",
		"与"
	],
	"画": [
		"划",
		"画",
		"劃",
		"畫"
	],
	"闘": [
		"斗",
		"鬭",
		"鬥",
		"闘",
		"鬪"
	],
	"鬥": [
		"斗",
		"鬭",
		"鬥",
		"闘",
		"鬪"
	],
	"鬭": [
		"斗",
		"鬭",
		"鬥",
		"闘",
		"鬪"
	],
	"鬪": [
		"斗",
		"鬭",
		"鬥",
		"闘",
		"鬪"
	],
	"闇": [
		"暗",
		"闇"
	],
	"図": [
		"図",
		"圖",
		"图"
	],
	"当": [
		"当",
		"噹",
		"當",
		"儅"
	],
	"閤": [
		"合",
		"閤",
		"阁"
	],
	"阁": [
		"合",
		"閤",
		"阁"
	],
	"罗": [
		"羅",
		"罗",
		"儸",
		"㑩",
		"囉",
		"啰"
	],
	"干": [
		"幹",
		"乾",
		"干"
	],
	"幹": [
		"幹",
		"干"
	],
	"乾": [
		"干",
		"乾",
		"亁",
		"乹"
	],
	"亁": [
		"乾",
		"亁",
		"乹"
	],
	"乹": [
		"乾",
		"亁",
		"乹"
	],
	"历": [
		"历",
		"歴",
		"歷",
		"暦",
		"曆"
	],
	"歴": [
		"历",
		"歴",
		"歷"
	],
	"歷": [
		"历",
		"歴",
		"歷"
	],
	"暦": [
		"历",
		"暦",
		"曆"
	],
	"曆": [
		"历",
		"暦",
		"曆"
	],
	"呻": [
		"呻",
		"申"
	],
	"覆": [
		"覆",
		"复"
	],
	"复": [
		"覆",
		"复",
		"復",
		"複"
	],
	"勉": [
		"免",
		"勉",
		"勉"
	],
	"勉": [
		"免",
		"勉",
		"勉"
	],
	"甦": [
		"甦",
		"蘇",
		"苏"
	],
	"忧": [
		"憂",
		"優"
	],
	"鹹": [
		"咸",
		"鹹"
	],
	"准": [
		"準",
		"准"
	],
	"準": [
		"準",
		"准",
		"凖"
	],
	"袮": [
		"袮",
		"祢"
	],
	"儘": [
		"儘",
		"侭",
		"盡",
		"尽"
	],
	"侭": [
		"儘",
		"侭"
	],
	"脏": [
		"脏",
		"髒",
		"臟"
	],
	"发": [
		"髮",
		"髪",
		"发"
	],
	"髮": [
		"發",
		"发",
		"髮",
		"髪"
	],
	"慾": [
		"慾",
		"欲"
	],
	"讚": [
		"讃",
		"讚",
		"贊",
		"赞",
		"賛"
	],
	"冲": [
		"冲",
		"沖",
		"衝"
	],
	"面": [
		"麵",
		"麪",
		"麺"
	],
	"鬚": [
		"鬚",
		"須",
		"须"
	],
	"揹": [
		"揹",
		"背"
	],
	"捲": [
		"捲",
		"卷",
		"巻"
	],
	"卷": [
		"捲",
		"卷",
		"巻",
		"劵",
		"券"
	],
	"巻": [
		"捲",
		"卷",
		"巻",
		"劵",
		"券"
	],
	"苏": [
		"苏",
		"蘇",
		"甦",
		"囌"
	],
	"瀏": [
		"瀏",
		"浏",
		"刘"
	],
	"浏": [
		"瀏",
		"浏",
		"刘"
	],
	"吁": [
		"籲",
		"吁"
	],
	"囉": [
		"囉",
		"啰",
		"罗",
		"羅"
	],
	"啰": [
		"囉",
		"啰",
		"罗",
		"羅"
	],
	"修": [
		"修",
		"俢"
	],
	"犟": [
		"犟",
		"強",
		"强"
	],
	"嗬": [
		"嗬",
		"呵"
	],
	"唿": [
		"唿",
		"呼"
	],
	"媮": [
		"媮",
		"偷"
	],
	"采": [
		"采",
		"採"
	],
	"彩": [
		"彩",
		"采"
	],
	"𠩺": [
		"𠩺",
		"釐"
	],
	"恶": [
		"恶",
		"噁",
		"惡",
		"悪"
	],
	"炰": [
		"炰",
		"炮"
	],
	"辟": [
		"辟",
		"闢",
		"避"
	],
	"避": [
		"辟",
		"避"
	],
	"闢": [
		"辟",
		"闢"
	],
	"滷": [
		"魯",
		"鲁",
		"滷",
		"鹵",
		"卤"
	],
	"鹵": [
		"魯",
		"鲁",
		"滷",
		"鹵",
		"卤"
	],
	"卤": [
		"魯",
		"鲁",
		"滷",
		"鹵",
		"卤"
	],
	"儓": [
		"儓",
		"檯"
	],
	"檯": [
		"儓",
		"檯"
	],
	"台": [
		"台",
		"檯",
		"臺",
		"颱"
	],
	"練": [
		"炼"
	],
	"练": [
		"炼"
	],
	"繫": [
		"系",
		"繫",
		"繋"
	],
	"繋": [
		"系",
		"繫",
		"繋"
	],
	"糓": [
		"谷",
		"穀",
		"糓"
	],
	"穀": [
		"谷",
		"穀",
		"糓"
	],
	"版": [
		"板"
	],
	"祕": [
		"密",
		"祕",
		"秘"
	],
	"秘": [
		"密",
		"祕",
		"秘"
	],
	"汇": [
		"彙",
		"匯"
	],
	"倂": [
		"倂",
		"併"
	],
	"併": [
		"倂",
		"併",
		"並",
		"并"
	],
	"幷": [
		"并"
	],
	"并": [
		"幷",
		"並",
		"并",
		"併"
	],
	"矇": [
		"蒙"
	],
	"濛": [
		"蒙"
	],
	"懞": [
		"蒙"
	],
	"煇": [
		"煇",
		"辉",
		"𪸩"
	],
	"𪸩": [
		"煇",
		"辉",
		"𪸩"
	],
	"签": [
		"籤",
		"簽"
	],
	"燻": [
		"燻",
		"熏",
		"薫",
		"薰"
	],
	"劍": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"砲": [
		"砲",
		"炮"
	],
	"偽": [
		"偽",
		"僞"
	],
	"內": [
		"內",
		"内"
	],
	"鶏": [
		"鶏",
		"鷄",
		"雞",
		"鸡"
	],
	"兎": [
		"兎",
		"兔"
	],
	"坏": [
		"坯",
		"坏",
		"壊",
		"壞"
	],
	"殻": [
		"殻",
		"殼",
		"壳"
	],
	"像": [
		"像",
		"象"
	],
	"蘇": [
		"苏",
		"蘇",
		"囌"
	],
	"館": [
		"館",
		"館",
		"舘",
		"馆"
	],
	"鳥": [
		"鳥",
		"鸟",
		"𫠓"
	],
	"視": [
		"視",
		"視",
		"视",
		"眎"
	],
	"険": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"絶": [
		"絶",
		"絕",
		"绝"
	],
	"鉄": [
		"鉄",
		"鐵",
		"铁",
		"鐡"
	],
	"諸": [
		"諸",
		"諸",
		"诸"
	],
	"尋": [
		"尋",
		"寻",
		"𡬶"
	],
	"裡": [
		"裡",
		"裏",
		"里"
	],
	"鑑": [
		"鑑",
		"鉴",
		"鑒"
	],
	"麵": [
		"麵",
		"麪",
		"麺"
	],
	"歲": [
		"歲",
		"歳",
		"岁"
	],
	"鐘": [
		"鐘",
		"鍾",
		"钟",
		"锺"
	],
	"會": [
		"會",
		"会",
		"㑹"
	],
	"塗": [
		"塗",
		"凃",
		"涂"
	],
	"話": [
		"話",
		"话",
		"䛡"
	],
	"蔘": [
		"蔘",
		"參",
		"参"
	],
	"労": [
		"労",
		"勞",
		"劳"
	],
	"国": [
		"国",
		"囯",
		"國"
	],
	"罵": [
		"罵",
		"骂",
		"駡"
	],
	"対": [
		"対",
		"對",
		"对"
	],
	"鏽": [
		"鏽",
		"銹",
		"锈"
	],
	"駄": [
		"駄",
		"䭾",
		"馱",
		"驮"
	],
	"薩": [
		"薩",
		"萨",
		"蕯"
	],
	"単": [
		"単",
		"單",
		"单"
	],
	"継": [
		"継",
		"繼",
		"继"
	],
	"驗": [
		"驗",
		"验",
		"騐",
		"験"
	],
	"団": [
		"团",
		"団",
		"團"
	],
	"麼": [
		"麼",
		"麽",
		"庅"
	],
	"戰": [
		"戦",
		"戰",
		"战"
	],
	"乡": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"餘": [
		"餘",
		"馀",
		"余"
	],
	"網": [
		"網",
		"䋄",
		"䋞",
		"网"
	],
	"託": [
		"託",
		"讬",
		"托"
	],
	"纖": [
		"纖",
		"纤",
		"縴",
		"繊"
	],
	"鍊": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"擊": [
		"撃",
		"擊",
		"击"
	],
	"實": [
		"實",
		"実",
		"实",
		"寔"
	],
	"於": [
		"於",
		"扵"
	],
	"證": [
		"證",
		"証",
		"证"
	],
	"據": [
		"據",
		"据",
		"拠"
	],
	"處": [
		"處",
		"处",
		"䖏",
		"処"
	],
	"瞪": [
		"瞪",
		"瞠",
		"眙"
	],
	"肢": [
		"肢",
		"胑"
	],
	"肉": [
		"肉",
		"宍",
		"𠕎"
	],
	"憂": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"廻": [
		"廻",
		"迴"
	],
	"録": [
		"録",
		"錄",
		"录"
	],
	"鎗": [
		"鎗",
		"槍",
		"枪"
	],
	"悠": [
		"悠",
		"滺"
	],
	"壶": [
		"壶",
		"壺",
		"壷"
	],
	"茲": [
		"茲",
		"兹",
		"玆"
	],
	"蓋": [
		"蓋",
		"盖",
		"葢"
	],
	"蹟": [
		"蹟",
		"跡",
		"迹"
	],
	"癒": [
		"癒",
		"瘉"
	],
	"辺": [
		"辺",
		"邊",
		"边",
		"邉"
	],
	"衛": [
		"衛",
		"衞",
		"卫"
	],
	"晚": [
		"晚",
		"晩"
	],
	"裸": [
		"裸",
		"躶"
	],
	"亀": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"凼": [
		"凼",
		"氹"
	],
	"艸": [
		"艸",
		"草"
	],
	"箚": [
		"箚",
		"剳"
	],
	"污": [
		"污",
		"汙",
		"汚"
	],
	"伙": [
		"伙",
		"夥"
	],
	"御": [
		"御",
		"禦"
	],
	"鬱": [
		"鬱",
		"郁"
	],
	"淩": [
		"淩",
		"凌"
	],
	"紮": [
		"紮",
		"扎"
	],
	"痴": [
		"痴",
		"癡"
	],
	"栖": [
		"栖",
		"棲"
	],
	"犇": [
		"犇",
		"奔"
	],
	"範": [
		"範",
		"范"
	],
	"薑": [
		"薑",
		"姜",
		"葁"
	],
	"樸": [
		"樸",
		"朴"
	],
	"諮": [
		"諮",
		"谘",
		"咨"
	],
	"撚": [
		"撚",
		"捻"
	],
	"喂": [
		"喂",
		"餵",
		"餧",
		"𫗭"
	],
	"淨": [
		"淨",
		"凈",
		"净"
	],
	"栗": [
		"栗",
		"慄"
	],
	"挽": [
		"挽",
		"輓"
	],
	"灶": [
		"灶",
		"竈"
	],
	"線": [
		"線",
		"缐",
		"綫",
		"线"
	],
	"盡": [
		"盡",
		"尽",
		"儘"
	],
	"黴": [
		"黴",
		"霉"
	],
	"周": [
		"周",
		"週"
	],
	"並": [
		"並",
		"并",
		"併"
	],
	"観": [
		"観",
		"觀",
		"观",
		"覌"
	],
	"遊": [
		"遊",
		"游"
	],
	"启": [
		"启",
		"啓",
		"啟",
		"啔"
	],
	"廄": [
		"廄",
		"厩",
		"廐",
		"廏"
	],
	"氣": [
		"気",
		"氣",
		"气"
	],
	"欲": [
		"慾",
		"欲"
	],
	"傑": [
		"傑",
		"杰"
	],
	"鍛": [
		"鍛",
		"锻",
		"煅"
	],
	"徵": [
		"徵",
		"徴"
	],
	"閒": [
		"閒",
		"𫔮",
		"閑",
		"闲"
	],
	"贊": [
		"贊",
		"赞",
		"賛"
	],
	"櫻": [
		"櫻",
		"桜",
		"樱"
	],
	"尨": [
		"尨",
		"狵"
	],
	"圈": [
		"圈",
		"圏"
	],
	"凶": [
		"凶",
		"兇"
	],
	"浜": [
		"浜",
		"濱",
		"滨"
	],
	"煙": [
		"煙",
		"烟",
		"菸"
	],
	"黒": [
		"黒",
		"黑"
	],
	"樂": [
		"樂",
		"乐",
		"楽"
	],
	"薬": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"劵": [
		"劵",
		"券",
		"卷"
	],
	"貳": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"隷": [
		"隷",
		"隸",
		"隶"
	],
	"姫": [
		"姫",
		"姬"
	],
	"薫": [
		"薫",
		"熏",
		"薰"
	],
	"籲": [
		"籲",
		"龥"
	],
	"齧": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"鹼": [
		"鹼",
		"碱",
		"硷"
	],
	"咸": [
		"咸",
		"鹹"
	],
	"穗": [
		"穗",
		"穂"
	],
	"廢": [
		"廢",
		"廃",
		"废"
	],
	"蹠": [
		"蹠",
		"跖"
	],
	"吒": [
		"吒",
		"咤"
	],
	"剷": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"擗": [
		"擗",
		"劈"
	],
	"核": [
		"核",
		"覈"
	],
	"脣": [
		"脣",
		"唇"
	],
	"升": [
		"升",
		"昇"
	],
	"磐": [
		"磐",
		"盤",
		"盘"
	],
	"溪": [
		"溪",
		"渓"
	],
	"谿": [
		"谿",
		"嵠"
	],
	"折": [
		"折",
		"摺"
	],
	"祐": [
		"祐",
		"佑"
	],
	"瓮": [
		"瓮",
		"罋",
		"甕"
	],
	"蹤": [
		"蹤",
		"踪",
		"踨"
	],
	"暗": [
		"闇",
		"暗"
	],
	"昵": [
		"昵",
		"暱"
	],
	"布": [
		"布",
		"佈"
	],
	"為": [
		"為",
		"为",
		"爲"
	],
	"綳": [
		"綳",
		"繃",
		"绷"
	],
	"痺": [
		"痺",
		"痹"
	],
	"痲": [
		"痲",
		"痳"
	],
	"雇": [
		"雇",
		"僱"
	],
	"敘": [
		"敘",
		"叙",
		"敍"
	],
	"盪": [
		"盪",
		"蕩",
		"荡"
	],
	"勛": [
		"勛",
		"勳",
		"勋",
		"勲"
	],
	"牆": [
		"牆",
		"墙",
		"墻"
	],
	"爾": [
		"爾",
		"尔",
		"尓"
	],
	"焰": [
		"焰",
		"焔"
	],
	"默": [
		"默",
		"黙"
	],
	"壓": [
		"壓",
		"压",
		"圧"
	],
	"廸": [
		"廸",
		"迪"
	],
	"曉": [
		"曉",
		"晓",
		"暁"
	],
	"霸": [
		"霸",
		"覇"
	],
	"霊": [
		"霊",
		"靈",
		"灵"
	],
	"泪": [
		"泪",
		"涙",
		"淚"
	],
	"牺": [
		"牺",
		"犠",
		"犧"
	],
	"藉": [
		"藉",
		"耤"
	],
	"噸": [
		"噸",
		"吨"
	],
	"俱": [
		"俱",
		"倶"
	],
	"粽": [
		"粽",
		"糉",
		"糭"
	],
	"向": [
		"向",
		"曏",
		"嚮"
	],
	"悽": [
		"悽",
		"淒",
		"凄"
	],
	"鱷": [
		"鱷",
		"鰐",
		"鳄"
	],
	"颜": [
		"颜",
		"顏",
		"顔"
	],
	"衝": [
		"衝",
		"沖",
		"冲"
	],
	"樑": [
		"樑",
		"梁"
	],
	"砂": [
		"砂",
		"沙"
	],
	"炭": [
		"炭",
		"碳"
	],
	"糸": [
		"糸",
		"絲",
		"丝"
	],
	"簷": [
		"簷",
		"檐"
	],
	"涌": [
		"涌",
		"湧"
	],
	"両": [
		"両",
		"两",
		"兩"
	],
	"家": [
		"家",
		"傢"
	],
	"妳": [
		"妳",
		"你"
	],
	"她": [
		"她",
		"他"
	],
	"藤": [
		"藤",
		"籐",
		"籘"
	],
	"嬉": [
		"嬉",
		"嘻"
	],
	"亘": [
		"亘",
		"亙"
	],
	"恆": [
		"恆",
		"恒"
	],
	"鶇": [
		"鶇",
		"鶫",
		"鸫"
	],
	"姉": [
		"姉",
		"姐",
		"姊"
	],
	"剁": [
		"剁",
		"刴"
	],
	"泄": [
		"泄",
		"洩"
	],
	"舖": [
		"舖",
		"铺",
		"鋪",
		"舗"
	],
	"效": [
		"效",
		"効"
	],
	"喻": [
		"喻",
		"喩"
	],
	"插": [
		"挿",
		"插",
		"揷"
	],
	"銳": [
		"銳",
		"鋭",
		"锐"
	],
	"權": [
		"權",
		"権",
		"权"
	],
	"経": [
		"経",
		"經",
		"经"
	],
	"歓": [
		"歓",
		"歡",
		"欢"
	],
	"孃": [
		"嬢",
		"孃"
	],
	"済": [
		"済",
		"濟",
		"济"
	],
	"收": [
		"収",
		"收"
	],
	"綠": [
		"綠",
		"緑",
		"绿"
	],
	"唖": [
		"唖",
		"啞",
		"哑"
	],
	"剿": [
		"剿",
		"勦",
		"𠞰"
	],
	"禍": [
		"禍",
		"禍",
		"祸"
	],
	"営": [
		"營",
		"営",
		"营"
	],
	"産": [
		"產",
		"産",
		"产"
	],
	"査": [
		"查",
		"査"
	],
	"絵": [
		"繪",
		"絵",
		"绘"
	],
	"懐": [
		"懷",
		"懐",
		"怀"
	],
	"釈": [
		"釋",
		"釈",
		"释"
	],
	"蔵": [
		"藏",
		"蔵"
	],
	"娯": [
		"娛",
		"娯",
		"娱"
	],
	"焼": [
		"燒",
		"焼",
		"烧"
	],
	"拡": [
		"擴",
		"拡",
		"扩"
	],
	"賎": [
		"賤",
		"賎",
		"贱"
	],
	"銭": [
		"錢",
		"銭",
		"钱"
	],
	"雑": [
		"雜",
		"雑",
		"杂"
	],
	"聴": [
		"聽",
		"聴",
		"听"
	],
	"帯": [
		"帶",
		"帯",
		"带"
	],
	"閲": [
		"閲",
		"阅"
	],
	"覧": [
		"覽",
		"覧",
		"览"
	],
	"悪": [
		"惡",
		"悪",
		"恶"
	],
	"亜": [
		"亞",
		"亜",
		"亚"
	],
	"氷": [
		"冰",
		"氷"
	],
	"县": [
		"県",
		"縣",
		"县"
	],
	"肅": [
		"粛",
		"肅",
		"肃"
	],
	"専": [
		"專",
		"専",
		"专"
	],
	"様": [
		"樣",
		"様",
		"样"
	],
	"関": [
		"關",
		"関",
		"关"
	],
	"檢": [
		"検",
		"檢",
		"检"
	],
	"侮": [
		"侮",
		"侮"
	],
	"沉": [
		"沉",
		"沈"
	],
	"嚐": [
		"嚐",
		"嘗",
		"尝"
	],
	"搾": [
		"搾",
		"榨"
	],
	"获": [
		"获",
		"獲",
		"穫"
	],
	"繮": [
		"繮",
		"缰",
		"韁"
	],
	"贋": [
		"贋",
		"贗",
		"赝"
	],
	"獃": [
		"呆"
	],
	"杯": [
		"杯",
		"盃"
	],
	"呪": [
		"呪",
		"咒",
		"詋"
	],
	"䇳": [
		"䇳",
		"笺",
		"箋",
		"牋"
	],
	"竝": [
		"竝",
		"𠀤"
	],
	"彷": [
		"彷",
		"徬"
	],
	"贑": [
		"贑",
		"𫎬"
	],
	"崖": [
		"崖",
		"崕",
		"厓"
	],
	"岩": [
		"岩",
		"巖",
		"巗",
		"巌"
	],
	"灕": [
		"灕",
		"漓"
	],
	"粘": [
		"粘",
		"黏"
	],
	"娴": [
		"娴",
		"嫺",
		"嫻"
	],
	"哗": [
		"哗",
		"嘩",
		"譁"
	],
	"拔": [
		"拔",
		"抜"
	],
	"湿": [
		"湿",
		"溼",
		"濕"
	],
	"稻": [
		"稻",
		"稲"
	],
	"楕": [
		"楕",
		"椭",
		"橢"
	],
	"毎": [
		"毎",
		"每"
	],
	"篦": [
		"篦",
		"箆"
	],
	"騨": [
		"騨",
		"驒",
		"驔"
	],
	"猛": [
		"猛",
		"勐"
	],
	"吿": [
		"吿",
		"告"
	],
	"刃": [
		"刃",
		"刄"
	],
	"教": [
		"教",
		"敎"
	],
	"蛎": [
		"蛎",
		"蜊",
		"蠣"
	],
	"步": [
		"步",
		"歩"
	],
	"劫": [
		"刦",
		"刧",
		"刼",
		"劫"
	],
	"鎚": [
		"鎚",
		"錘",
		"锤"
	],
	"捶": [
		"搥"
	],
	"剑": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"剣": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"劎": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"劒": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"剱": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"劔": [
		"劍",
		"剑",
		"剣",
		"劎",
		"劒",
		"剱",
		"劔"
	],
	"炮": [
		"砲",
		"炮"
	],
	"僞": [
		"偽",
		"僞"
	],
	"内": [
		"內",
		"内"
	],
	"鷄": [
		"鶏",
		"鷄",
		"雞",
		"鸡"
	],
	"雞": [
		"鶏",
		"鷄",
		"雞",
		"鸡"
	],
	"鸡": [
		"鶏",
		"鷄",
		"雞",
		"鸡"
	],
	"兔": [
		"兎",
		"兔"
	],
	"坯": [
		"坯",
		"坏",
		"壊",
		"壞"
	],
	"壊": [
		"坯",
		"坏",
		"壊",
		"壞"
	],
	"壞": [
		"坯",
		"坏",
		"壊",
		"壞"
	],
	"殼": [
		"殻",
		"殼",
		"壳"
	],
	"壳": [
		"殻",
		"殼",
		"壳"
	],
	"象": [
		"像",
		"象"
	],
	"囌": [
		"苏",
		"蘇",
		"囌"
	],
	"館": [
		"館",
		"館",
		"舘",
		"馆"
	],
	"舘": [
		"館",
		"館",
		"舘",
		"馆"
	],
	"馆": [
		"館",
		"館",
		"舘",
		"馆"
	],
	"鸟": [
		"鳥",
		"鸟",
		"𫠓"
	],
	"𫠓": [
		"鳥",
		"鸟",
		"𫠓"
	],
	"視": [
		"視",
		"視",
		"视",
		"眎"
	],
	"视": [
		"視",
		"視",
		"视",
		"眎"
	],
	"眎": [
		"視",
		"視",
		"视",
		"眎"
	],
	"險": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"险": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"嶮": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"崄": [
		"険",
		"險",
		"险",
		"嶮",
		"崄"
	],
	"絕": [
		"絶",
		"絕",
		"绝"
	],
	"绝": [
		"絶",
		"絕",
		"绝"
	],
	"鐵": [
		"鉄",
		"鐵",
		"铁",
		"鐡"
	],
	"铁": [
		"鉄",
		"鐵",
		"铁",
		"鐡"
	],
	"鐡": [
		"鉄",
		"鐵",
		"铁",
		"鐡"
	],
	"諸": [
		"諸",
		"諸",
		"诸"
	],
	"诸": [
		"諸",
		"諸",
		"诸"
	],
	"寻": [
		"尋",
		"寻",
		"𡬶"
	],
	"𡬶": [
		"尋",
		"寻",
		"𡬶"
	],
	"裏": [
		"裡",
		"裏",
		"里"
	],
	"里": [
		"裡",
		"裏",
		"里"
	],
	"鉴": [
		"鑑",
		"鉴",
		"鑒"
	],
	"鑒": [
		"鑑",
		"鉴",
		"鑒"
	],
	"麪": [
		"麵",
		"麪",
		"麺"
	],
	"麺": [
		"麵",
		"麪",
		"麺"
	],
	"歳": [
		"歲",
		"歳",
		"岁"
	],
	"岁": [
		"歲",
		"歳",
		"岁"
	],
	"鍾": [
		"鐘",
		"鍾",
		"钟",
		"锺"
	],
	"钟": [
		"鐘",
		"鍾",
		"钟",
		"锺"
	],
	"锺": [
		"鐘",
		"鍾",
		"钟",
		"锺"
	],
	"会": [
		"會",
		"会",
		"㑹"
	],
	"㑹": [
		"會",
		"会",
		"㑹"
	],
	"凃": [
		"塗",
		"凃",
		"涂"
	],
	"涂": [
		"塗",
		"凃",
		"涂"
	],
	"髪": [
		"髮",
		"髪"
	],
	"话": [
		"話",
		"话",
		"䛡"
	],
	"䛡": [
		"話",
		"话",
		"䛡"
	],
	"參": [
		"蔘",
		"參",
		"参"
	],
	"参": [
		"蔘",
		"參",
		"参"
	],
	"勞": [
		"労",
		"勞",
		"劳"
	],
	"劳": [
		"労",
		"勞",
		"劳"
	],
	"囯": [
		"国",
		"囯",
		"國"
	],
	"國": [
		"国",
		"囯",
		"國"
	],
	"骂": [
		"罵",
		"骂",
		"駡"
	],
	"駡": [
		"罵",
		"骂",
		"駡"
	],
	"對": [
		"対",
		"對",
		"对"
	],
	"对": [
		"対",
		"對",
		"对"
	],
	"銹": [
		"鏽",
		"銹",
		"锈"
	],
	"锈": [
		"鏽",
		"銹",
		"锈"
	],
	"䭾": [
		"駄",
		"䭾",
		"馱",
		"驮"
	],
	"馱": [
		"駄",
		"䭾",
		"馱",
		"驮"
	],
	"驮": [
		"駄",
		"䭾",
		"馱",
		"驮"
	],
	"萨": [
		"薩",
		"萨",
		"蕯"
	],
	"蕯": [
		"薩",
		"萨",
		"蕯"
	],
	"單": [
		"単",
		"單",
		"单"
	],
	"单": [
		"単",
		"單",
		"单"
	],
	"繼": [
		"継",
		"繼",
		"继"
	],
	"继": [
		"継",
		"繼",
		"继"
	],
	"验": [
		"驗",
		"验",
		"騐",
		"験"
	],
	"騐": [
		"驗",
		"验",
		"騐",
		"験"
	],
	"験": [
		"驗",
		"验",
		"騐",
		"験"
	],
	"团": [
		"团",
		"団",
		"團"
	],
	"團": [
		"团",
		"団",
		"團"
	],
	"麽": [
		"麼",
		"麽",
		"庅"
	],
	"庅": [
		"麼",
		"麽",
		"庅"
	],
	"戦": [
		"戦",
		"戰",
		"战"
	],
	"战": [
		"戦",
		"戰",
		"战"
	],
	"郷": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"鄕": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"鄉": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"鄊": [
		"郷",
		"鄕",
		"鄉",
		"鄊",
		"乡"
	],
	"馀": [
		"餘",
		"馀",
		"余"
	],
	"余": [
		"餘",
		"馀",
		"余"
	],
	"䋄": [
		"網",
		"䋄",
		"䋞",
		"网"
	],
	"䋞": [
		"網",
		"䋄",
		"䋞",
		"网"
	],
	"网": [
		"網",
		"䋄",
		"䋞",
		"网"
	],
	"讬": [
		"託",
		"讬",
		"托"
	],
	"托": [
		"託",
		"讬",
		"托"
	],
	"纤": [
		"纖",
		"纤",
		"縴",
		"繊"
	],
	"縴": [
		"纖",
		"纤",
		"縴",
		"繊"
	],
	"繊": [
		"纖",
		"纤",
		"縴",
		"繊"
	],
	"錬": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"𫔀": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"炼": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"煉": [
		"鍊",
		"錬",
		"𫔀",
		"炼",
		"煉"
	],
	"撃": [
		"撃",
		"擊",
		"击"
	],
	"击": [
		"撃",
		"擊",
		"击"
	],
	"実": [
		"實",
		"実",
		"实",
		"寔"
	],
	"实": [
		"實",
		"実",
		"实",
		"寔"
	],
	"寔": [
		"實",
		"実",
		"实",
		"寔"
	],
	"扵": [
		"於",
		"扵"
	],
	"証": [
		"證",
		"証",
		"证"
	],
	"证": [
		"證",
		"証",
		"证"
	],
	"据": [
		"據",
		"据",
		"拠"
	],
	"拠": [
		"據",
		"据",
		"拠"
	],
	"处": [
		"處",
		"处",
		"䖏",
		"処"
	],
	"䖏": [
		"處",
		"处",
		"䖏",
		"処"
	],
	"処": [
		"處",
		"处",
		"䖏",
		"処"
	],
	"瞠": [
		"瞪",
		"瞠",
		"眙"
	],
	"眙": [
		"瞪",
		"瞠",
		"眙"
	],
	"胑": [
		"肢",
		"胑"
	],
	"宍": [
		"肉",
		"宍",
		"𠕎"
	],
	"𠕎": [
		"肉",
		"宍",
		"𠕎"
	],
	"𢝊": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"𢚧": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"𢟜": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"懮": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"𨗫": [
		"憂",
		"𢝊",
		"𢚧",
		"𢟜",
		"懮",
		"𨗫"
	],
	"迴": [
		"廻",
		"迴"
	],
	"錄": [
		"録",
		"錄",
		"录"
	],
	"录": [
		"録",
		"錄",
		"录"
	],
	"槍": [
		"鎗",
		"槍",
		"枪"
	],
	"枪": [
		"鎗",
		"槍",
		"枪"
	],
	"滺": [
		"悠",
		"滺"
	],
	"壺": [
		"壶",
		"壺",
		"壷"
	],
	"壷": [
		"壶",
		"壺",
		"壷"
	],
	"兹": [
		"茲",
		"兹",
		"玆"
	],
	"玆": [
		"茲",
		"兹",
		"玆"
	],
	"盖": [
		"蓋",
		"盖",
		"葢"
	],
	"葢": [
		"蓋",
		"盖",
		"葢"
	],
	"跡": [
		"蹟",
		"跡",
		"迹"
	],
	"迹": [
		"蹟",
		"跡",
		"迹"
	],
	"瘉": [
		"癒",
		"瘉"
	],
	"邊": [
		"辺",
		"邊",
		"边",
		"邉"
	],
	"边": [
		"辺",
		"邊",
		"边",
		"邉"
	],
	"邉": [
		"辺",
		"邊",
		"边",
		"邉"
	],
	"凖": [
		"準",
		"凖"
	],
	"衞": [
		"衛",
		"衞",
		"卫"
	],
	"卫": [
		"衛",
		"衞",
		"卫"
	],
	"晩": [
		"晚",
		"晩"
	],
	"躶": [
		"裸",
		"躶"
	],
	"龜": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"龟": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"𪚧": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"𪚿": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"𠃾": [
		"亀",
		"龜",
		"龟",
		"𪚧",
		"𪚿",
		"𠃾"
	],
	"氹": [
		"凼",
		"氹"
	],
	"草": [
		"艸",
		"草"
	],
	"剳": [
		"箚",
		"剳"
	],
	"復": [
		"复",
		"復",
		"複"
	],
	"複": [
		"复",
		"復",
		"複"
	],
	"汙": [
		"污",
		"汙",
		"汚"
	],
	"汚": [
		"污",
		"汙",
		"汚"
	],
	"夥": [
		"伙",
		"夥"
	],
	"禦": [
		"御",
		"禦"
	],
	"郁": [
		"鬱",
		"郁"
	],
	"凌": [
		"淩",
		"凌"
	],
	"扎": [
		"紮",
		"扎"
	],
	"癡": [
		"痴",
		"癡"
	],
	"棲": [
		"栖",
		"棲"
	],
	"奔": [
		"犇",
		"奔"
	],
	"范": [
		"範",
		"范"
	],
	"姜": [
		"薑",
		"姜",
		"葁"
	],
	"葁": [
		"薑",
		"姜",
		"葁"
	],
	"朴": [
		"樸",
		"朴"
	],
	"谘": [
		"諮",
		"谘",
		"咨"
	],
	"咨": [
		"諮",
		"谘",
		"咨"
	],
	"捻": [
		"撚",
		"捻"
	],
	"餵": [
		"喂",
		"餵",
		"餧",
		"𫗭"
	],
	"餧": [
		"喂",
		"餵",
		"餧",
		"𫗭"
	],
	"𫗭": [
		"喂",
		"餵",
		"餧",
		"𫗭"
	],
	"凈": [
		"淨",
		"凈",
		"净"
	],
	"净": [
		"淨",
		"凈",
		"净"
	],
	"慄": [
		"栗",
		"慄"
	],
	"輓": [
		"挽",
		"輓"
	],
	"竈": [
		"灶",
		"竈"
	],
	"缐": [
		"線",
		"缐",
		"綫",
		"线"
	],
	"綫": [
		"線",
		"缐",
		"綫",
		"线"
	],
	"线": [
		"線",
		"缐",
		"綫",
		"线"
	],
	"尽": [
		"盡",
		"尽",
		"儘"
	],
	"霉": [
		"黴",
		"霉"
	],
	"週": [
		"周",
		"週"
	],
	"讃": [
		"讚",
		"讃"
	],
	"觀": [
		"観",
		"觀",
		"观",
		"覌"
	],
	"观": [
		"観",
		"觀",
		"观",
		"覌"
	],
	"覌": [
		"観",
		"觀",
		"观",
		"覌"
	],
	"游": [
		"遊",
		"游"
	],
	"啓": [
		"启",
		"啓",
		"啟",
		"啔"
	],
	"啟": [
		"启",
		"啓",
		"啟",
		"啔"
	],
	"啔": [
		"启",
		"啓",
		"啟",
		"啔"
	],
	"厩": [
		"廄",
		"厩",
		"廐",
		"廏"
	],
	"廐": [
		"廄",
		"厩",
		"廐",
		"廏"
	],
	"廏": [
		"廄",
		"厩",
		"廐",
		"廏"
	],
	"気": [
		"気",
		"氣",
		"气"
	],
	"气": [
		"気",
		"氣",
		"气"
	],
	"杰": [
		"傑",
		"杰"
	],
	"锻": [
		"鍛",
		"锻",
		"煅"
	],
	"煅": [
		"鍛",
		"锻",
		"煅"
	],
	"徴": [
		"徵",
		"徴"
	],
	"𫔮": [
		"閒",
		"𫔮",
		"閑",
		"闲"
	],
	"閑": [
		"閒",
		"𫔮",
		"閑",
		"闲"
	],
	"闲": [
		"閒",
		"𫔮",
		"閑",
		"闲"
	],
	"赞": [
		"贊",
		"赞",
		"賛"
	],
	"賛": [
		"贊",
		"赞",
		"賛"
	],
	"桜": [
		"櫻",
		"桜",
		"樱"
	],
	"樱": [
		"櫻",
		"桜",
		"樱"
	],
	"狵": [
		"尨",
		"狵"
	],
	"圏": [
		"圈",
		"圏"
	],
	"兇": [
		"凶",
		"兇"
	],
	"濱": [
		"浜",
		"濱",
		"滨"
	],
	"滨": [
		"浜",
		"濱",
		"滨"
	],
	"烟": [
		"煙",
		"烟",
		"菸"
	],
	"菸": [
		"煙",
		"烟",
		"菸"
	],
	"黑": [
		"黒",
		"黑"
	],
	"乐": [
		"樂",
		"乐",
		"楽"
	],
	"楽": [
		"樂",
		"乐",
		"楽"
	],
	"藥": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"药": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"葯": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"𣛙": [
		"薬",
		"藥",
		"药",
		"葯",
		"𣛙"
	],
	"券": [
		"劵",
		"券",
		"卷"
	],
	"贰": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"弐": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"貮": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"𢎐": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"二": [
		"貳",
		"贰",
		"弐",
		"貮",
		"𢎐",
		"二"
	],
	"隸": [
		"隷",
		"隸",
		"隶"
	],
	"隶": [
		"隷",
		"隸",
		"隶"
	],
	"姬": [
		"姫",
		"姬"
	],
	"熏": [
		"薫",
		"熏",
		"薰"
	],
	"薰": [
		"薫",
		"熏",
		"薰"
	],
	"龥": [
		"籲",
		"龥"
	],
	"啮": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"𪘂": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"囓": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"噛": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"嚙": [
		"齧",
		"啮",
		"𪘂",
		"囓",
		"噛",
		"嚙"
	],
	"碱": [
		"鹼",
		"碱",
		"硷"
	],
	"硷": [
		"鹼",
		"碱",
		"硷"
	],
	"穂": [
		"穗",
		"穂"
	],
	"廃": [
		"廢",
		"廃",
		"废"
	],
	"废": [
		"廢",
		"廃",
		"废"
	],
	"跖": [
		"蹠",
		"跖"
	],
	"咤": [
		"吒",
		"咤"
	],
	"鏟": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"铲": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"刬": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"剗": [
		"剷",
		"鏟",
		"铲",
		"刬",
		"剗"
	],
	"劈": [
		"擗",
		"劈"
	],
	"覈": [
		"核",
		"覈"
	],
	"唇": [
		"脣",
		"唇"
	],
	"昇": [
		"升",
		"昇"
	],
	"盤": [
		"磐",
		"盤",
		"盘"
	],
	"盘": [
		"磐",
		"盤",
		"盘"
	],
	"渓": [
		"溪",
		"渓"
	],
	"嵠": [
		"谿",
		"嵠"
	],
	"摺": [
		"折",
		"摺"
	],
	"佑": [
		"祐",
		"佑"
	],
	"罋": [
		"瓮",
		"罋",
		"甕"
	],
	"甕": [
		"瓮",
		"罋",
		"甕"
	],
	"踪": [
		"蹤",
		"踪",
		"踨"
	],
	"踨": [
		"蹤",
		"踪",
		"踨"
	],
	"暱": [
		"昵",
		"暱"
	],
	"佈": [
		"布",
		"佈"
	],
	"为": [
		"為",
		"为",
		"爲"
	],
	"爲": [
		"為",
		"为",
		"爲"
	],
	"繃": [
		"綳",
		"繃",
		"绷"
	],
	"绷": [
		"綳",
		"繃",
		"绷"
	],
	"痹": [
		"痺",
		"痹"
	],
	"痳": [
		"痲",
		"痳"
	],
	"僱": [
		"雇",
		"僱"
	],
	"叙": [
		"敘",
		"叙",
		"敍"
	],
	"敍": [
		"敘",
		"叙",
		"敍"
	],
	"蕩": [
		"盪",
		"蕩",
		"荡"
	],
	"荡": [
		"盪",
		"蕩",
		"荡"
	],
	"勳": [
		"勛",
		"勳",
		"勋",
		"勲"
	],
	"勋": [
		"勛",
		"勳",
		"勋",
		"勲"
	],
	"勲": [
		"勛",
		"勳",
		"勋",
		"勲"
	],
	"墙": [
		"牆",
		"墙",
		"墻"
	],
	"墻": [
		"牆",
		"墙",
		"墻"
	],
	"尔": [
		"爾",
		"尔",
		"尓"
	],
	"尓": [
		"爾",
		"尔",
		"尓"
	],
	"焔": [
		"焰",
		"焔"
	],
	"黙": [
		"默",
		"黙"
	],
	"压": [
		"壓",
		"压",
		"圧"
	],
	"圧": [
		"壓",
		"压",
		"圧"
	],
	"迪": [
		"廸",
		"迪"
	],
	"晓": [
		"曉",
		"晓",
		"暁"
	],
	"暁": [
		"曉",
		"晓",
		"暁"
	],
	"覇": [
		"霸",
		"覇"
	],
	"靈": [
		"霊",
		"靈",
		"灵"
	],
	"灵": [
		"霊",
		"靈",
		"灵"
	],
	"涙": [
		"泪",
		"涙",
		"淚"
	],
	"淚": [
		"泪",
		"涙",
		"淚"
	],
	"犠": [
		"牺",
		"犠",
		"犧"
	],
	"犧": [
		"牺",
		"犠",
		"犧"
	],
	"耤": [
		"藉",
		"耤"
	],
	"吨": [
		"噸",
		"吨"
	],
	"倶": [
		"俱",
		"倶"
	],
	"糉": [
		"粽",
		"糉",
		"糭"
	],
	"糭": [
		"粽",
		"糉",
		"糭"
	],
	"曏": [
		"向",
		"曏",
		"嚮"
	],
	"嚮": [
		"向",
		"曏",
		"嚮"
	],
	"淒": [
		"悽",
		"淒",
		"凄"
	],
	"凄": [
		"悽",
		"淒",
		"凄"
	],
	"鰐": [
		"鱷",
		"鰐",
		"鳄"
	],
	"鳄": [
		"鱷",
		"鰐",
		"鳄"
	],
	"顏": [
		"颜",
		"顏",
		"顔"
	],
	"顔": [
		"颜",
		"顏",
		"顔"
	],
	"沖": [
		"衝",
		"沖",
		"冲"
	],
	"梁": [
		"樑",
		"梁"
	],
	"沙": [
		"砂",
		"沙"
	],
	"碳": [
		"炭",
		"碳"
	],
	"絲": [
		"糸",
		"絲",
		"丝"
	],
	"丝": [
		"糸",
		"絲",
		"丝"
	],
	"檐": [
		"簷",
		"檐"
	],
	"湧": [
		"涌",
		"湧"
	],
	"两": [
		"両",
		"两",
		"兩"
	],
	"兩": [
		"両",
		"两",
		"兩"
	],
	"傢": [
		"家",
		"傢"
	],
	"你": [
		"妳",
		"你"
	],
	"他": [
		"她",
		"他"
	],
	"籐": [
		"藤",
		"籐",
		"籘"
	],
	"籘": [
		"藤",
		"籐",
		"籘"
	],
	"嘻": [
		"嬉",
		"嘻"
	],
	"亙": [
		"亘",
		"亙"
	],
	"恒": [
		"恆",
		"恒"
	],
	"鶫": [
		"鶇",
		"鶫",
		"鸫"
	],
	"鸫": [
		"鶇",
		"鶫",
		"鸫"
	],
	"姐": [
		"姉",
		"姐",
		"姊"
	],
	"姊": [
		"姉",
		"姐",
		"姊"
	],
	"刴": [
		"剁",
		"刴"
	],
	"洩": [
		"泄",
		"洩"
	],
	"铺": [
		"舖",
		"铺",
		"鋪",
		"舗"
	],
	"鋪": [
		"舖",
		"铺",
		"鋪",
		"舗"
	],
	"舗": [
		"舖",
		"铺",
		"鋪",
		"舗"
	],
	"効": [
		"效",
		"効"
	],
	"喩": [
		"喻",
		"喩"
	],
	"挿": [
		"挿",
		"插",
		"揷"
	],
	"揷": [
		"挿",
		"插",
		"揷"
	],
	"鋭": [
		"銳",
		"鋭",
		"锐"
	],
	"锐": [
		"銳",
		"鋭",
		"锐"
	],
	"権": [
		"權",
		"権",
		"权"
	],
	"权": [
		"權",
		"権",
		"权"
	],
	"經": [
		"経",
		"經",
		"经"
	],
	"经": [
		"経",
		"經",
		"经"
	],
	"歡": [
		"歓",
		"歡",
		"欢"
	],
	"欢": [
		"歓",
		"歡",
		"欢"
	],
	"嬢": [
		"嬢",
		"孃"
	],
	"濟": [
		"済",
		"濟",
		"济"
	],
	"济": [
		"済",
		"濟",
		"济"
	],
	"収": [
		"収",
		"收"
	],
	"緑": [
		"綠",
		"緑",
		"绿"
	],
	"绿": [
		"綠",
		"緑",
		"绿"
	],
	"啞": [
		"唖",
		"啞",
		"哑"
	],
	"哑": [
		"唖",
		"啞",
		"哑"
	],
	"勦": [
		"剿",
		"勦",
		"𠞰"
	],
	"𠞰": [
		"剿",
		"勦",
		"𠞰"
	],
	"禍": [
		"禍",
		"禍",
		"祸"
	],
	"祸": [
		"禍",
		"禍",
		"祸"
	],
	"營": [
		"營",
		"営",
		"营"
	],
	"营": [
		"營",
		"営",
		"营"
	],
	"產": [
		"產",
		"産",
		"产"
	],
	"产": [
		"產",
		"産",
		"产"
	],
	"查": [
		"查",
		"査"
	],
	"繪": [
		"繪",
		"絵",
		"绘"
	],
	"绘": [
		"繪",
		"絵",
		"绘"
	],
	"懷": [
		"懷",
		"懐",
		"怀"
	],
	"怀": [
		"懷",
		"懐",
		"怀"
	],
	"釋": [
		"釋",
		"釈",
		"释"
	],
	"释": [
		"釋",
		"釈",
		"释"
	],
	"藏": [
		"藏",
		"蔵"
	],
	"娛": [
		"娛",
		"娯",
		"娱"
	],
	"娱": [
		"娛",
		"娯",
		"娱"
	],
	"燒": [
		"燒",
		"焼",
		"烧"
	],
	"烧": [
		"燒",
		"焼",
		"烧"
	],
	"擴": [
		"擴",
		"拡",
		"扩"
	],
	"扩": [
		"擴",
		"拡",
		"扩"
	],
	"賤": [
		"賤",
		"賎",
		"贱"
	],
	"贱": [
		"賤",
		"賎",
		"贱"
	],
	"錢": [
		"錢",
		"銭",
		"钱"
	],
	"钱": [
		"錢",
		"銭",
		"钱"
	],
	"雜": [
		"雜",
		"雑",
		"杂"
	],
	"杂": [
		"雜",
		"雑",
		"杂"
	],
	"聽": [
		"聽",
		"聴",
		"听"
	],
	"听": [
		"聽",
		"聴",
		"听"
	],
	"帶": [
		"帶",
		"帯",
		"带"
	],
	"带": [
		"帶",
		"帯",
		"带"
	],
	"阅": [
		"閲",
		"阅"
	],
	"覽": [
		"覽",
		"覧",
		"览"
	],
	"览": [
		"覽",
		"覧",
		"览"
	],
	"惡": [
		"惡",
		"悪",
		"恶"
	],
	"亞": [
		"亞",
		"亜",
		"亚"
	],
	"亚": [
		"亞",
		"亜",
		"亚"
	],
	"冰": [
		"冰",
		"氷"
	],
	"県": [
		"県",
		"縣",
		"县"
	],
	"縣": [
		"県",
		"縣",
		"县"
	],
	"粛": [
		"粛",
		"肅",
		"肃"
	],
	"肃": [
		"粛",
		"肅",
		"肃"
	],
	"專": [
		"專",
		"専",
		"专"
	],
	"专": [
		"專",
		"専",
		"专"
	],
	"樣": [
		"樣",
		"様",
		"样"
	],
	"样": [
		"樣",
		"様",
		"样"
	],
	"關": [
		"關",
		"関",
		"关"
	],
	"关": [
		"關",
		"関",
		"关"
	],
	"検": [
		"検",
		"檢",
		"检"
	],
	"检": [
		"検",
		"檢",
		"检"
	],
	"侮": [
		"侮",
		"侮"
	],
	"沈": [
		"沉",
		"沈"
	],
	"嘗": [
		"嚐",
		"嘗",
		"尝"
	],
	"尝": [
		"嚐",
		"嘗",
		"尝"
	],
	"榨": [
		"搾",
		"榨"
	],
	"獲": [
		"获",
		"獲",
		"穫"
	],
	"穫": [
		"获",
		"獲",
		"穫"
	],
	"缰": [
		"繮",
		"缰",
		"韁"
	],
	"韁": [
		"繮",
		"缰",
		"韁"
	],
	"贗": [
		"贋",
		"贗",
		"赝"
	],
	"赝": [
		"贋",
		"贗",
		"赝"
	],
	"呆": [
		"呆"
	],
	"盃": [
		"杯",
		"盃"
	],
	"咒": [
		"呪",
		"咒",
		"詋"
	],
	"詋": [
		"呪",
		"咒",
		"詋"
	],
	"笺": [
		"䇳",
		"笺",
		"箋",
		"牋"
	],
	"箋": [
		"䇳",
		"笺",
		"箋",
		"牋"
	],
	"牋": [
		"䇳",
		"笺",
		"箋",
		"牋"
	],
	"𠀤": [
		"竝",
		"𠀤"
	],
	"徬": [
		"彷",
		"徬"
	],
	"𫎬": [
		"贑",
		"𫎬"
	],
	"崕": [
		"崖",
		"崕",
		"厓"
	],
	"厓": [
		"崖",
		"崕",
		"厓"
	],
	"巖": [
		"岩",
		"巖",
		"巗",
		"巌"
	],
	"巗": [
		"岩",
		"巖",
		"巗",
		"巌"
	],
	"巌": [
		"岩",
		"巖",
		"巗",
		"巌"
	],
	"漓": [
		"灕",
		"漓"
	],
	"黏": [
		"粘",
		"黏"
	],
	"嫺": [
		"娴",
		"嫺",
		"嫻"
	],
	"嫻": [
		"娴",
		"嫺",
		"嫻"
	],
	"嘩": [
		"哗",
		"嘩",
		"譁"
	],
	"譁": [
		"哗",
		"嘩",
		"譁"
	],
	"抜": [
		"拔",
		"抜"
	],
	"溼": [
		"湿",
		"溼",
		"濕"
	],
	"濕": [
		"湿",
		"溼",
		"濕"
	],
	"稲": [
		"稻",
		"稲"
	],
	"椭": [
		"楕",
		"椭",
		"橢"
	],
	"橢": [
		"楕",
		"椭",
		"橢"
	],
	"每": [
		"毎",
		"每"
	],
	"箆": [
		"篦",
		"箆"
	],
	"驒": [
		"騨",
		"驒",
		"驔"
	],
	"驔": [
		"騨",
		"驒",
		"驔"
	],
	"勐": [
		"猛",
		"勐"
	],
	"告": [
		"吿",
		"告"
	],
	"刄": [
		"刃",
		"刄"
	],
	"敎": [
		"教",
		"敎"
	],
	"蜊": [
		"蛎",
		"蜊",
		"蠣"
	],
	"蠣": [
		"蛎",
		"蜊",
		"蠣"
	],
	"歩": [
		"步",
		"歩"
	],
	"刦": [
		"刦",
		"刧",
		"刼",
		"劫"
	],
	"刧": [
		"刦",
		"刧",
		"刼",
		"劫"
	],
	"刼": [
		"刦",
		"刧",
		"刼",
		"劫"
	],
	"錘": [
		"鎚",
		"錘",
		"锤"
	],
	"锤": [
		"鎚",
		"錘",
		"锤"
	],
	"搥": [
		"搥"
	]
};

export const _table_cn: ISimpleTable = {
	"羅": "罗",
	"惡": "恶",
	"蘇": "苏",
	"館": "馆"
};

